// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27%3E%3Cpath d=%27M3 3v18h18%27/%3E%3Cpath d=%27m19 9-5 5-4-4-3 3%27/%3E%3Cpath d=%27M14 12v8%27/%3E%3Cpath d=%27M10 12v8%27/%3E%3Cpath d=%27M6 12v8%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27%3E%3Cpath d=%27M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z%27/%3E%3Cpolyline points=%2714 2 14 8 20 8%27/%3E%3Cline x1=%2716%27 y1=%2713%27 x2=%278%27 y2=%2713%27/%3E%3Cline x1=%2716%27 y1=%2717%27 x2=%278%27 y2=%2717%27/%3E%3Cpolyline points=%2710 9 9 9 8 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%2710%27/%3E%3Cpolyline points=%2712 6 12 12 16 14%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%2710%27/%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%276%27/%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Основные цвета */
  --primary-orange: #FF5722;
  --primary-orange-dark: #E64A19;
  --primary-orange-light: #FF8A65;

  /* Текстовые цвета */
  --text-primary: #212121;
  --text-secondary: #424242;
  --text-muted: #757575;
  --text-inverse: #FFFFFF;

  /* Фоновые цвета */
  --bg-primary: #FFFFFF;
  --bg-secondary: #F5F5F5;
  --bg-tertiary: #EEEEEE;
  --bg-surface: #FAFAFA;

  /* Темная тема */
  --dark-bg-primary: #121212;
  --dark-bg-secondary: #1E1E1E;
  --dark-bg-tertiary: #2D2D2D;
  --dark-bg-surface: #262626;

  --dark-text-primary: #FFFFFF;
  --dark-text-secondary: #E0E0E0;
  --dark-text-muted: #BDBDBD;

  /* Акцентные цвета */
  --success: #4CAF50;
  --warning: #FF9800;
  --error: #F44336;
  --info: #2196F3;

  /* Границы и тени */
  --border-light: #E0E0E0;
  --border-medium: #BDBDBD;
  --border-dark: #757575;

  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.12);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.15);

  /* Переходы */
  --transition-fast: 0.15s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  transition: background-color var(--transition-normal), color var(--transition-normal);
}

body.dark-theme {
  background-color: var(--dark-bg-primary);
  color: var(--dark-text-primary);
}

/* Типографика */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 1rem;
  color: var(--text-primary);
}

body.dark-theme h1,
body.dark-theme h2,
body.dark-theme h3,
body.dark-theme h4,
body.dark-theme h5,
body.dark-theme h6 {
  color: var(--dark-text-primary);
}

h1 { font-size: 2.5rem; }
h2 { font-size: 2rem; }
h3 { font-size: 1.75rem; }
h4 { font-size: 1.5rem; }
h5 { font-size: 1.25rem; }
h6 { font-size: 1rem; }

p {
  margin-bottom: 1rem;
  color: var(--text-secondary);
}

body.dark-theme p {
  color: var(--dark-text-secondary);
}

/* Контейнеры */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  width: 100%;
}

.container-fluid {
  width: 100%;
  padding: 0 1.5rem;
}

/* Карточки */
.card {
  background-color: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-normal);
}

.card:hover {
  box-shadow: var(--shadow-md);
}

body.dark-theme .card {
  background-color: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.card-header {
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

body.dark-theme .card-header {
  border-color: var(--border-dark);
}

/* Кнопки */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-height: 44px;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--primary-orange);
  color: var(--text-inverse);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-orange-dark);
  box-shadow: var(--shadow-md);
}

.btn-secondary {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-medium);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--bg-secondary);
  border-color: var(--border-dark);
}

.btn-outline {
  background-color: transparent;
  color: var(--primary-orange);
  border: 1px solid var(--primary-orange);
}

.btn-outline:hover:not(:disabled) {
  background-color: var(--primary-orange);
  color: var(--text-inverse);
}

.btn-success {
  background-color: var(--success);
  color: var(--text-inverse);
}

.btn-danger {
  background-color: var(--error);
  color: var(--text-inverse);
}

.btn-sm {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  min-height: 36px;
}

.btn-lg {
  padding: 1rem 2rem;
  font-size: 1rem;
  min-height: 52px;
}

/* Формы */
.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-primary);
}

body.dark-theme .form-label {
  color: var(--dark-text-primary);
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  font-size: 0.875rem;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.form-control:focus {
  outline: none;
  border-color: var(--primary-orange);
  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.1);
}

body.dark-theme .form-control {
  background-color: var(--dark-bg-secondary);
  border-color: var(--border-dark);
  color: var(--dark-text-primary);
}

body.dark-theme .form-control:focus {
  border-color: var(--primary-orange);
  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.2);
}

select.form-control {
  cursor: pointer;
}

/* Навигация */
.navbar {
  background-color: var(--bg-primary);
  border-bottom: 1px solid var(--border-light);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: var(--shadow-sm);
}

body.dark-theme .navbar {
  background-color: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.navbar-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}

.navbar-brand {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--primary-orange);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.navbar-brand:hover {
  color: var(--primary-orange-dark);
}

.navbar-nav {
  display: flex;
  list-style: none;
  gap: 0.5rem;
  align-items: center;
  margin: 0;
  padding: 0;
}

.nav-link {
  color: var(--text-secondary);
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all var(--transition-fast);
  font-weight: 500;
}

.nav-link:hover,
.nav-link.active {
  color: var(--primary-orange);
  background-color: var(--bg-secondary);
}

body.dark-theme .nav-link {
  color: var(--dark-text-secondary);
}

body.dark-theme .nav-link:hover,
body.dark-theme .nav-link.active {
  color: var(--primary-orange);
  background-color: var(--dark-bg-tertiary);
}

/* Выпадающие меню в навигации */
.nav-dropdown {
  position: relative;
}

.nav-dropdown > .nav-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.dropdown-arrow {
  display: inline-block;
  transition: transform 0.3s ease;
  transform: rotate(0deg);
}

.nav-dropdown:hover .dropdown-arrow {
  transform: rotate(90deg);
}

.nav-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  box-shadow: var(--shadow-lg);
  min-width: 200px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all var(--transition-fast);
  z-index: 1001;
  list-style: none;
  margin: 0;
}

body.dark-theme .nav-dropdown-menu {
  background-color: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.nav-dropdown:hover .nav-dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.nav-dropdown-menu .nav-link {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0;
  white-space: nowrap;
}

.nav-dropdown-menu .nav-link:hover {
  background-color: var(--bg-secondary);
}

body.dark-theme .nav-dropdown-menu .nav-link:hover {
  background-color: var(--dark-bg-tertiary);
}

/* Боковая панель */
.sidebar {
  background-color: var(--bg-primary);
  border-right: 1px solid var(--border-light);
  width: 280px;
  min-height: calc(100vh - 64px);
  padding: 1.5rem;
}

body.dark-theme .sidebar {
  background-color: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.sidebar-nav {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-item {
  margin-bottom: 0.25rem;
}

.sidebar-link {
  display: block;
  padding: 0.75rem 1rem;
  color: var(--text-secondary);
  text-decoration: none;
  border-radius: 4px;
  transition: all var(--transition-fast);
  font-weight: 500;
}

.sidebar-link:hover,
.sidebar-link.active {
  background-color: var(--primary-orange);
  color: var(--text-inverse);
}

body.dark-theme .sidebar-link {
  color: var(--dark-text-secondary);
}

/* Основной контент */
.main-content {
  flex: 1 1;
  padding: 1.5rem;
}

.layout {
  display: flex;
  min-height: calc(100vh - 64px);
}

/* Переключатель темы */
.theme-toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color var(--transition-fast);
  color: var(--text-secondary);
}

.theme-toggle:hover {
  background-color: var(--bg-secondary);
}

body.dark-theme .theme-toggle {
  color: var(--dark-text-secondary);
}

body.dark-theme .theme-toggle:hover {
  background-color: var(--dark-bg-tertiary);
}

/* Аватары */
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background-color: var(--bg-tertiary);
}

.avatar-large {
  width: 100px;
  height: 100px;
}

/* Прогресс бары */
.progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--bg-tertiary);
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background-color: var(--primary-orange);
  transition: width var(--transition-normal);
  border-radius: 4px;
}

/* Статусы */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.status-pending {
  background-color: var(--bg-tertiary);
  color: var(--text-muted);
}

.status-submitted {
  background-color: var(--primary-orange-light);
  color: var(--text-inverse);
}

.status-approved {
  background-color: var(--success);
  color: var(--text-inverse);
}

.status-rejected {
  background-color: var(--error);
  color: var(--text-inverse);
}

/* Загрузка файлов */
.file-upload {
  border: 2px dashed var(--border-medium);
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  border-radius: 4px;
  background-color: var(--bg-surface);
}

.file-upload:hover {
  border-color: var(--primary-orange);
  background-color: var(--bg-secondary);
}

body.dark-theme .file-upload {
  background-color: var(--dark-bg-surface);
  border-color: var(--border-dark);
}

body.dark-theme .file-upload:hover {
  border-color: var(--primary-orange);
  background-color: var(--dark-bg-tertiary);
}

/* Уведомления */
.notification-item {
  padding: 1rem;
/*  border-left: 4px solid var(--primary-orange);*/
  background-color: var(--bg-primary);
  margin-bottom: 1rem;
  border-radius: 0 4px 4px 0;
  box-shadow: var(--shadow-sm);
}

body.dark-theme .notification-item {
  background-color: var(--dark-bg-secondary);
}

/* Скроллбары */
.dashboard-scroll {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.dashboard-scroll::-webkit-scrollbar {
  width: 6px;
}

.dashboard-scroll::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 4px;
}

.dashboard-scroll::-webkit-scrollbar-thumb {
  background: var(--border-medium);
  border-radius: 4px;
}

.dashboard-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--border-dark);
}

body.dark-theme .dashboard-scroll::-webkit-scrollbar-track {
  background: var(--dark-bg-tertiary);
}

body.dark-theme .dashboard-scroll::-webkit-scrollbar-thumb {
  background: var(--border-dark);
}

/* Карточки пользователей */
.user-card {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid var(--border-light);
  margin-bottom: 0.75rem;
  border-radius: 4px;
  background-color: var(--bg-primary);
  transition: all var(--transition-fast);
}

.user-card:hover {
  box-shadow: var(--shadow-sm);
}

body.dark-theme .user-card {
  background-color: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.user-avatar {
  margin-right: 1rem;
  flex-shrink: 0;
}

.user-info h4 {
  margin: 0 0 0.25rem 0;
  color: var(--primary-orange);
  font-size: 1rem;
  font-weight: 600;
}

.user-info p {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.875rem;
}

body.dark-theme .user-info p {
  color: var(--dark-text-muted);
}

/* Состояния */
.loading {
  text-align: center;
  padding: 2rem;
  color: var(--text-muted);
}

.error {
  color: var(--error);
  padding: 1rem;
  border: 1px solid var(--error);
  background-color: rgba(244, 67, 54, 0.1);
  border-radius: 4px;
  margin-bottom: 1rem;
}

body.dark-theme .error {
  background-color: rgba(244, 67, 54, 0.2);
}

.success {
  color: var(--success);
  padding: 1rem;
  border: 1px solid var(--success);
  background-color: rgba(76, 175, 80, 0.1);
  border-radius: 4px;
  margin-bottom: 1rem;
}

body.dark-theme .success {
  background-color: rgba(76, 175, 80, 0.2);
}

/* Сетка */
.grid {
  display: grid;
  gap: 1.5rem;
}

.grid-cols-1 { grid-template-columns: 1fr; }
.grid-cols-2 { grid-template-columns: repeat(2, 1fr); }
.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }
.grid-cols-4 { grid-template-columns: repeat(4, 1fr); }

@media (max-width: 768px) {
  .grid-cols-2,
  .grid-cols-3,
  .grid-cols-4 {
    grid-template-columns: 1fr;
  }

  .navbar-content {
    padding: 0 1rem;
  }

  .container {
    padding: 0 1rem;
  }

  .sidebar {
    width: 100%;
  }

  .layout {
    flex-direction: column;
  }
}

/* Стили для таблицы должностей */
.positions-table {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-sm);
}

body.dark-theme .positions-table {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.positions-table thead th {
  background-color: var(--bg-surface);
  border-bottom: 2px solid var(--primary-orange);
  font-weight: 600;
  color: var(--text-primary);
  padding: 1rem;
  text-align: left;
}

body.dark-theme .positions-table thead th {
  background-color: var(--dark-bg-tertiary);
  color: var(--dark-text-primary);
}

.positions-table tbody tr {
  border-bottom: 1px solid var(--border-light);
  transition: background-color var(--transition-fast);
}

body.dark-theme .positions-table tbody tr {
  border-color: var(--border-dark);
}

.positions-table tbody tr:hover {
  background-color: var(--bg-surface);
}

body.dark-theme .positions-table tbody tr:hover {
  background-color: var(--dark-bg-tertiary);
}

.positions-table tbody td {
  padding: 1rem;
  vertical-align: middle;
  color: var(--text-secondary);
}

body.dark-theme .positions-table tbody td {
  color: var(--dark-text-secondary);
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* Иконки для кнопок */
.fas {
  font-size: 0.875rem;
}

/* Кнопки в таблице */
.btn-sm {
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 4px;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-fast);
}

.btn-sm:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* Иконки в кнопках */
.fas {
  font-size: 0.75rem;
}

/* Стили для таблицы достижений */
.achievements-table {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-sm);
}

body.dark-theme .achievements-table {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.achievements-table thead th {
  background-color: var(--bg-surface);
  border-bottom: 2px solid var(--primary-orange);
  font-weight: 600;
  color: var(--text-primary);
  padding: 1rem;
  text-align: left;
}

body.dark-theme .achievements-table thead th {
  background-color: var(--dark-bg-tertiary);
  color: var(--dark-text-primary);
}

.achievements-table tbody tr {
  border-bottom: 1px solid var(--border-light);
  transition: background-color var(--transition-fast);
}

body.dark-theme .achievements-table tbody tr {
  border-color: var(--border-dark);
}

.achievements-table tbody tr:hover {
  background-color: var(--bg-surface);
}

body.dark-theme .achievements-table tbody tr:hover {
  background-color: var(--dark-bg-tertiary);
}

.achievements-table tbody td {
  padding: 1rem;
  vertical-align: middle;
  color: var(--text-secondary);
}

body.dark-theme .achievements-table tbody td {
  color: var(--dark-text-secondary);
}

.achievements-table .truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  cursor: help;
}

/* Утилиты */
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }

.mb-0 { margin-bottom: 0; }
.mb-1 { margin-bottom: 0.25rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 1rem; }
.mb-4 { margin-bottom: 1.5rem; }
.mb-5 { margin-bottom: 2rem; }

.mt-0 { margin-top: 0; }
.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 1rem; }
.mt-4 { margin-top: 1.5rem; }
.mt-5 { margin-top: 2rem; }

.p-0 { padding: 0; }
.p-1 { padding: 0.25rem; }
.p-2 { padding: 0.5rem; }
.p-3 { padding: 1rem; }
.p-4 { padding: 1.5rem; }
.p-5 { padding: 2rem; }

.d-flex { display: flex; }
.d-block { display: block; }
.d-none { display: none; }

.justify-content-between { justify-content: space-between; }
.justify-content-center { justify-content: center; }
.align-items-center { align-items: center; }

.w-100 { width: 100%; }
.h-100 { height: 100%; }

/* Дашборд */
.dashboard-content {
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 2rem;
  margin-top: 2rem;
}

@media (max-width: 1024px) {
  .dashboard-content {
    grid-template-columns: 1fr;
  }
}

.dashboard-main {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.dashboard-section {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  padding: 1.5rem;
  box-shadow: var(--shadow-sm);
}

body.dark-theme .dashboard-section {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-light);
}

body.dark-theme .section-header {
  border-color: var(--border-dark);
}

.section-header h2 {
  color: var(--primary-orange);
  margin: 0;
  font-size: 1.5rem;
}

.view-all-button {
  background: var(--primary-orange);
  color: var(--text-inverse);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  transition: background-color var(--transition-fast);
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.view-all-button:hover {
  background: var(--primary-orange-dark);
  text-decoration: none;
  color: var(--text-inverse);
}

/* Статистика дашборда */
.dashboard-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
/*  margin-bottom: 3rem;*/
}

.stat-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-sm);
}

body.dark-theme .stat-card {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.stat-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-surface);
  border-radius: 4px;
  flex-shrink: 0;
}

body.dark-theme .stat-icon {
  background: var(--dark-bg-tertiary);
}

/* Иконки для статистики */
.icon-chart::before {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  background: var(--primary-orange);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/contain no-repeat;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/contain no-repeat;
}

.icon-task::before {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  background: var(--primary-orange);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/contain no-repeat;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/contain no-repeat;
}

.icon-time::before {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  background: var(--primary-orange);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center/contain no-repeat;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center/contain no-repeat;
}

.icon-target::before {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  background: var(--primary-orange);
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center/contain no-repeat;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center/contain no-repeat;
}

.stat-content h3 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--primary-orange);
  margin: 0 0 0.25rem 0;
}

.stat-content p {
  color: var(--text-muted);
  margin: 0;
  font-size: 0.875rem;
}

/* Сетка достижений */
.achievements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}

.achievement-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-surface);
  border-radius: 4px;
  border: 1px solid var(--border-light);
  transition: all var(--transition-fast);
}

body.dark-theme .achievement-card {
  background: var(--dark-bg-tertiary);
  border-color: var(--border-dark);
}

.achievement-icon {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
}

body.dark-theme .achievement-icon {
  background: var(--dark-bg-secondary);
}

.achievement-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.default-icon {
  font-size: 1.5rem;
}

.default-achievement-icon {
  width: 100%;
  height: 100%;
  background: var(--primary-orange);
  color: var(--text-inverse);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border-radius: 4px;
}

.achievement-info {
  flex: 1 1;
  min-width: 0;
}

.achievement-info h4 {
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
  font-size: 0.875rem;
  font-weight: 600;
}

body.dark-theme .achievement-info h4 {
  color: var(--dark-text-primary);
}

.progress-text {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

/* Список заданий */
.tasks-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.task-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-surface);
  border-radius: 4px;
  border: 1px solid var(--border-light);
  transition: all var(--transition-fast);
  cursor: pointer;
}

body.dark-theme .task-item {
  background: var(--dark-bg-tertiary);
  border-color: var(--border-dark);
}

.task-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.task-status {
  flex-shrink: 0;
}

.task-content {
  flex: 1 1;
  min-width: 0;
}

.task-content h4 {
  color: var(--text-primary);
  margin: 0 0 0.25rem 0;
  font-size: 0.875rem;
  font-weight: 600;
}

body.dark-theme .task-content h4 {
  color: var(--dark-text-primary);
}

.task-date {
  color: var(--text-muted);
  font-size: 0.75rem;
  margin: 0;
}

/* Боковая панель дашборда */
.dashboard-sidebar {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.sidebar-section {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  padding: 1.5rem;
  box-shadow: var(--shadow-sm);
}

body.dark-theme .sidebar-section {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.sidebar-section h3 {
  color: var(--primary-orange);
  margin: 0 0 1rem 0;
  font-size: 1.25rem;
}

/* Список команды */
.team-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.team-member {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: var(--bg-surface);
  border-radius: 4px;
  transition: all var(--transition-fast);
}

body.dark-theme .team-member {
  background: var(--dark-bg-tertiary);
}

.member-avatar {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.member-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: var(--primary-orange);
  color: var(--text-inverse);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.875rem;
  border-radius: 4px;
}

.member-info {
  flex: 1 1;
  min-width: 0;
}

.member-info h4 {
  color: var(--text-primary);
  margin: 0 0 0.25rem 0;
  font-size: 0.875rem;
  font-weight: 600;
}

body.dark-theme .member-info h4 {
  color: var(--dark-text-primary);
}

.member-info p {
  color: var(--text-muted);
  font-size: 0.75rem;
  margin: 0;
}

/* Список уведомлений */
.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.notifications-list .notification-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem;
  background: var(--bg-surface);
  border-radius: 4px;
/*  border-left: 3px solid var(--primary-orange);*/
  transition: all var(--transition-fast);
  cursor: pointer;
}

.notifications-list .notification-item:hover {
  background: var(--bg-hover);
  transform: translateX(2px);
}

body.dark-theme .notifications-list .notification-item {
  background: var(--dark-bg-tertiary);
}

body.dark-theme .notifications-list .notification-item:hover {
  background: var(--dark-bg-secondary);
}

.notification-type {
  flex-shrink: 0;
  margin-top: 0.25rem;
}

.notification-icon {
  width: 24px;
  height: 24px;
  background: var(--primary-orange);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-inverse);
  font-size: 12px;
  font-weight: bold;
}

.icon-profile::before {
  content: "П";
}

.icon-info::before {
  content: "i";
}

.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-content h4 {
  color: var(--text-primary);
  margin: 0 0 0.25rem 0;
  font-size: 0.875rem;
  font-weight: 600;
}

body.dark-theme .notification-content h4 {
  color: var(--dark-text-primary);
}

.notification-content p {
  color: var(--text-secondary);
  font-size: 0.75rem;
  margin: 0 0 0.25rem 0;
  line-height: 1.4;
}

body.dark-theme .notification-content p {
  color: var(--dark-text-secondary);
}

.notification-date {
  color: var(--text-muted);
  font-size: 0.625rem;
  margin: 0;
}

/* Форма уведомлений */
.notification-form {
  margin-bottom: 2rem;
}

.notification-form .card {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  padding: 1.5rem;
  box-shadow: var(--shadow-sm);
}

body.dark-theme .notification-form .card {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.notification-form h3 {
  color: var(--primary-orange);
  margin: 0 0 1.5rem 0;
  font-size: 1.25rem;
}

.notification-form .form-group {
  margin-bottom: 1.5rem;
}

.notification-form .form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-primary);
}

body.dark-theme .notification-form .form-label {
  color: var(--dark-text-primary);
}

.notification-form .form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  font-size: 0.875rem;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

body.dark-theme .notification-form .form-control {
  background-color: var(--dark-bg-secondary);
  border-color: var(--border-dark);
  color: var(--dark-text-primary);
}

.notification-form .form-control:focus {
  outline: none;
  border-color: var(--primary-orange);
  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.1);
}

.notification-form textarea.form-control {
  resize: vertical;
  min-height: 100px;
}

.notification-form .d-flex {
  display: flex;
}

.notification-form .gap-2 {
  gap: 0.5rem;
}

.notification-form .justify-content-end {
  justify-content: flex-end;
}

.notification-form .mt-3 {
  margin-top: 1rem;
}

/* Страница администрирования уведомлений */
.notifications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.notification-item-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  padding: 1rem;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-fast);
}

body.dark-theme .notification-item-card {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.notification-item-card:hover {
  box-shadow: var(--shadow-md);
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-light);
}

body.dark-theme .notification-header {
  border-color: var(--border-dark);
}

.notification-type-badge {
  background: var(--primary-orange);
  color: var(--text-inverse);
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.notification-date {
  color: var(--text-muted);
  font-size: 0.875rem;
}

.notification-content h4 {
  color: var(--primary-orange);
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 600;
}

body.dark-theme .notification-content h4 {
  color: var(--primary-orange);
}

.notification-content p {
  color: var(--text-secondary);
  margin: 0 0 1rem 0;
  line-height: 1.5;
}

body.dark-theme .notification-content p {
  color: var(--dark-text-secondary);
}

.notification-actions {
  display: flex;
  justify-content: flex-end;
}

.notification-files {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--border-light);
}

.file-item {
  margin: 0.25rem 0;
}

.file-link {
  display: inline-flex;
  align-items: center;
  color: var(--primary-blue);
  text-decoration: none;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.file-link:hover {
  background-color: var(--bg-hover);
  text-decoration: underline;
}

.btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
}

/* Модальные окна */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  cursor: pointer;
  padding: 2rem;
  overflow-y: auto;
}

.modal-content {
  position: relative;
  background-color: var(--bg-surface);
  border-radius: 4px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-width: 95vw;
  max-height: 95vh;
  overflow: hidden;
}

/* Улучшенная темная тема для модальных окон */
body.dark-theme .modal-overlay {
  background-color: rgba(0, 0, 0, 0.95);
}

body.dark-theme .modal-content {
  background-color: var(--dark-bg-surface);
  border: 1px solid var(--border-dark);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
}

/* Темная тема для текста в модальных окнах */
body.dark-theme .modal-content h1,
body.dark-theme .modal-content h2,
body.dark-theme .modal-content h3,
body.dark-theme .modal-content h4,
body.dark-theme .modal-content h5,
body.dark-theme .modal-content h6 {
  color: var(--dark-text-primary);
}

body.dark-theme .modal-content p,
body.dark-theme .modal-content div {
  color: var(--dark-text-secondary);
}

body.dark-theme .modal-content strong {
  color: var(--dark-text-primary);
}

/* Темная тема для заголовков модальных окон */
body.dark-theme .modal-header {
  background-color: var(--dark-bg-secondary);
  border-bottom: 1px solid var(--border-dark);
}

body.dark-theme .modal-header h2,
body.dark-theme .modal-header h3 {
  color: var(--primary-orange);
}

/* Темная тема для информационных блоков в модальных окнах */
body.dark-theme .modal-info-section {
  background-color: var(--dark-bg-secondary);
  border: 1px solid var(--border-dark);
}

body.dark-theme .modal-info-section .info-label {
  color: var(--dark-text-muted);
}

body.dark-theme .modal-info-section .info-value {
  color: var(--dark-text-primary);
}

/* Темная тема для кнопок в модальных окнах */
body.dark-theme .modal-overlay button {
  background: var(--dark-bg-secondary);
  color: var(--dark-text-primary);
  border: 1px solid var(--border-dark);
}

body.dark-theme .modal-overlay button:hover {
  background: var(--dark-bg-tertiary);
  border-color: var(--primary-orange);
}

/* Темная тема для кнопок действий в модальных окнах */
body.dark-theme .modal-action-btn {
  background: var(--dark-bg-secondary);
  color: var(--dark-text-primary);
  border: 1px solid var(--border-dark);
}

body.dark-theme .modal-action-btn:hover {
  background: var(--dark-bg-tertiary);
  border-color: var(--primary-orange);
}

body.dark-theme .modal-action-btn.approve {
  background: var(--primary-orange);
  color: white;
  border-color: var(--primary-orange);
}

body.dark-theme .modal-action-btn.approve:hover {
  background: var(--primary-orange-dark);
  border-color: var(--primary-orange-dark);
}

body.dark-theme .modal-action-btn.reject {
  background: #F44336;
  color: white;
  border-color: #F44336;
}

body.dark-theme .modal-action-btn.reject:hover {
  background: #D32F2F;
  border-color: #D32F2F;
}

/* Темная тема для форм в модальных окнах */
body.dark-theme .modal-form textarea {
  background-color: var(--dark-bg-secondary);
  border: 1px solid var(--border-dark);
  color: var(--dark-text-primary);
}

body.dark-theme .modal-form textarea:focus {
  border-color: var(--primary-orange);
  box-shadow: 0 0 0 2px rgba(230, 74, 25, 0.2);
}

body.dark-theme .modal-form label {
  color: var(--dark-text-primary);
}

/* Темная тема для статусов в модальных окнах */
body.dark-theme .modal-status-badge {
  background-color: var(--dark-bg-tertiary);
  color: var(--dark-text-secondary);
  border: 1px solid var(--border-dark);
}

body.dark-theme .modal-status-badge.status-pending {
  background-color: rgba(255, 152, 0, 0.2);
  color: #FF9800;
  border-color: #FF9800;
}

body.dark-theme .modal-status-badge.status-submitted {
  background-color: rgba(33, 150, 243, 0.2);
  color: #2196F3;
  border-color: #2196F3;
}

body.dark-theme .modal-status-badge.status-approved {
  background-color: rgba(76, 175, 80, 0.2);
  color: #4CAF50;
  border-color: #4CAF50;
}

body.dark-theme .modal-status-badge.status-rejected {
  background-color: rgba(244, 67, 54, 0.2);
  color: #F44336;
  border-color: #F44336;
}

/* Темная тема для файлов в модальных окнах */
body.dark-theme .modal-file-item {
  background-color: var(--dark-bg-secondary);
  border: 1px solid var(--border-dark);
}

body.dark-theme .modal-file-item:hover {
  background-color: var(--dark-bg-tertiary);
  border-color: var(--primary-orange);
}

body.dark-theme .modal-file-item .file-name {
  color: var(--dark-text-primary);
}

body.dark-theme .modal-file-item .file-type {
  color: var(--dark-text-muted);
}

/* Стили для модального окна уведомлений */
.notification-modal-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 1000 !important;
  padding: 2rem !important;
}

body.dark-theme .notification-modal-overlay {
  background-color: rgba(0, 0, 0, 0.9) !important;
}

.notification-modal-content {
  background-color: var(--bg-surface) !important;
  border-radius: 4px !important;
  padding: 2rem !important;
  max-width: 900px !important;
  width: 95% !important;
  max-height: 90vh !important;
  overflow-y: auto !important;
  position: relative !important;
  border: 1px solid var(--border-medium) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
}

body.dark-theme .notification-modal-content {
  background-color: var(--dark-bg-surface) !important;
  border-color: var(--border-dark) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8) !important;
}

.notification-modal-close {
  position: absolute !important;
  top: 1rem !important;
  right: 1rem !important;
  background: rgba(255, 255, 255, 0.9) !important;
  border: none !important;
  border-radius: 4px !important;
  width: 36px !important;
  height: 36px !important;
  font-size: 20px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: var(--text-primary) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.2s ease !important;
}

body.dark-theme .notification-modal-close {
  background: var(--dark-bg-secondary) !important;
  color: var(--dark-text-primary) !important;
  border: 1px solid var(--border-dark) !important;
}

.notification-modal-close:hover {
  background: var(--primary-orange) !important;
  color: white !important;
}

.notification-modal-header {
  margin-bottom: 2rem !important;
}

.notification-modal-title-row {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 0.75rem !important;
}

.notification-modal-title-row .notification-icon {
  margin-right: 1rem !important;
  width: 32px !important;
  height: 32px !important;
}

.notification-modal-title {
  margin: 0 !important;
  color: var(--primary-orange) !important;
  font-size: 1.75rem !important;
  font-weight: 600 !important;
}

body.dark-theme .notification-modal-title {
  color: var(--primary-orange) !important;
}

.notification-modal-date {
  margin: 0 !important;
  color: var(--text-muted) !important;
  font-size: 0.9rem !important;
}

body.dark-theme .notification-modal-date {
  color: var(--dark-text-muted) !important;
}

.notification-modal-message {
  margin-bottom: 2rem !important;
}

.notification-modal-message p {
  margin: 0 !important;
  line-height: 1.7 !important;
  color: var(--text-primary) !important;
  font-size: 1.05rem !important;
  white-space: pre-wrap !important;
}

body.dark-theme .notification-modal-message p {
  color: var(--dark-text-primary) !important;
}

.notification-modal-files {
  margin-top: 1rem !important;
}

.notification-modal-files-title {
  margin-bottom: 1.5rem !important;
  color: var(--text-primary) !important;
  font-size: 1.25rem !important;
  font-weight: 600 !important;
}

body.dark-theme .notification-modal-files-title {
  color: var(--dark-text-primary) !important;
}

.notification-modal-files-grid {
  display: grid !important;
  gap: 1rem !important;
}

.notification-modal-file-item {
  display: flex !important;
  align-items: center !important;
  padding: 1rem !important;
  background-color: var(--bg-hover) !important;
  border-radius: 4px !important;
  border: 1px solid var(--border-light) !important;
  transition: all 0.2s ease !important;
}

body.dark-theme .notification-modal-file-item {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--border-dark) !important;
}

.notification-modal-file-item:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

body.dark-theme .notification-modal-file-item:hover {
  background-color: var(--dark-bg-tertiary) !important;
  border-color: var(--primary-orange) !important;
}

.notification-modal-file-preview {
  width: 80px !important;
  height: 80px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 4px !important;
  margin-right: 1.5rem !important;
  cursor: pointer !important;
  transition: transform 0.2s ease !important;
  font-size: 2rem !important;
  background-color: var(--primary-blue) !important;
  color: white !important;
}

.notification-modal-file-preview:hover {
  transform: scale(1.05) !important;
}

.notification-modal-file-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 4px !important;
}

.notification-modal-file-icon {
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 2rem !important;
}

.notification-modal-file-info {
  flex: 1 1 !important;
}

.notification-modal-file-name {
  margin: 0 0 0.25rem 0 !important;
  font-weight: 600 !important;
  color: var(--text-primary) !important;
  font-size: 1.05rem !important;
}

body.dark-theme .notification-modal-file-name {
  color: var(--dark-text-primary) !important;
}

.notification-modal-file-details {
  margin: 0 !important;
  font-size: 0.9rem !important;
  color: var(--text-muted) !important;
}

body.dark-theme .notification-modal-file-details {
  color: var(--dark-text-muted) !important;
}

.notification-modal-file-actions {
  display: flex !important;
  gap: 0.75rem !important;
}

.notification-modal-file-link {
  padding: 0.75rem 1.25rem !important;
  background-color: var(--primary-blue) !important;
  color: black !important;
  text-decoration: none !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  font-size: 0.9rem !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3) !important;
  display: inline-block !important;
}

body.dark-theme .notification-modal-file-link {
  color: white !important;
}

.notification-modal-file-link:hover {
  background-color: #1e40af !important;
  transform: translateY(-1px) !important;
  text-decoration: none !important;
  color: white !important;
}

.notification-modal-download-btn {
  padding: 0.75rem 1.25rem !important;
  background-color: var(--primary-orange) !important;
  color: black !important;
  border: none !important;
  border-radius: 4px !important;
  font-size: 0.9rem !important;
  font-weight: 500 !important;
  display: inline-block !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 4px rgba(251, 146, 60, 0.3) !important;
  cursor: pointer !important;
}

body.dark-theme .notification-modal-download-btn {
  color: white !important;
}

.notification-modal-download-btn:hover {
  background-color: #ea580c !important;
  transform: translateY(-1px) !important;
  color: white !important;
}

.modal-overlay button {
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 4px;
  color: var(--text-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;
  font-weight: 500;
}

body.dark-theme .modal-overlay button {
  background: var(--dark-bg-secondary);
  color: var(--dark-text-primary);
  border: 1px solid var(--border-dark);
}

.modal-overlay button:hover {
  transform: scale(1.05);
}

.modal-overlay button:active {
  transform: scale(0.95);
}
@media (max-width: 768px) {
  .dashboard-content {
    margin-top: 1rem;
  }

  .dashboard-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .stat-card {
    padding: 1rem;
  }

  .stat-icon {
    width: 50px;
    height: 50px;
  }

  .stat-content h3 {
    font-size: 1.5rem;
  }

  .achievements-grid {
    grid-template-columns: 1fr;
  }

  .achievement-card {
    padding: 0.75rem;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
.public-dashboard {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--bg-primary);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.dark-theme .public-dashboard {
  background: var(--dark-bg-primary);
}

.dashboard-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.public-dashboard-card {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
}

/* Экран загрузки */
.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 2rem;
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid var(--border-light);
  border-top: 4px solid var(--primary-orange);
  border-radius: 4px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Анимации перехода */
.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-enter-active {
  transform: translateX(0);
  opacity: 1;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-exit {
  transform: translateX(0);
  opacity: 1;
}

.slide-exit-active {
  transform: translateX(-100%);
  opacity: 0;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Карточка пользователя */
.user-showcase {
  display: flex;
  width: 100%;
  height: 100%;
}

.user-avatar-section {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--bg-surface) 0%, var(--bg-secondary) 100%);
  overflow: hidden;
}

body.dark-theme .user-avatar-section {
  background: linear-gradient(135deg, var(--dark-bg-tertiary) 0%, var(--dark-bg-secondary) 100%);
}

.user-avatar-large {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.user-avatar-large[style] {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-inverse);
  font-weight: bold;
  font-size: clamp(6rem, 15vw, 12rem);
}

.user-info-section {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem;
}

.user-name {
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 700;
  color: var(--primary-orange);
  margin: 0 0 2rem 0;
  line-height: 1.1;
}

.user-details {
  font-size: clamp(1.2rem, 3vw, 2rem);
  color: var(--text-secondary);
  margin: 1rem 0;
}

body.dark-theme .user-details {
  color: var(--dark-text-secondary);
}

.role-badge {
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 0;
  font-weight: 600;
  font-size: clamp(1rem, 2.5vw, 1.5rem);
  margin-top: 2rem;
  background: var(--primary-orange);
  color: var(--text-inverse);
}

.notification-message-content {
  margin-top: 2rem;
}

.notification-message-content .notification-message {
  font-size: clamp(1.2rem, 3vw, 1.8rem);
  line-height: 1.4;
  color: var(--text-secondary);
  margin: 0;
}

body.dark-theme .notification-message-content .notification-message {
  color: var(--dark-text-secondary);
}

/* Карточка уведомления */
.notification-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;
  background: linear-gradient(135deg, var(--bg-surface) 0%, var(--bg-secondary) 100%);
}

body.dark-theme .notification-card {
  background: linear-gradient(135deg, var(--dark-bg-tertiary) 0%, var(--dark-bg-secondary) 100%);
}

.notification-header {
  display: flex;
  align-items: center;
  gap: 3rem;
  margin-bottom: 3rem;
}

.notification-icon {
  width: 40px;
  height: 40px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  color: var(--text-inverse);
  flex-shrink: 0;
}

.icon-profile {
  background: var(--primary-orange);
}

.icon-info {
  background: var(--info);
}

.notification-title h2 {
  margin: 0 0 1rem 0;
  color: var(--text-primary);
  font-size: clamp(2rem, 5vw, 3.5rem);
  text-align: center;
}

body.dark-theme .notification-title h2 {
  color: var(--dark-text-primary);
}

.notification-date {
  margin: 0;
  color: var(--text-muted);
  text-align: center;
}

.notification-content {
  text-align: center;
  max-width: 800px;
}

.notification-message {
  font-size: clamp(1.5rem, 4vw, 2.5rem);
  line-height: 1.4;
  color: var(--text-secondary);
  margin: 0;
}

body.dark-theme .notification-message {
  color: var(--dark-text-secondary);
}

/* Адаптивность */
@media (max-width: 768px) {
  .user-showcase {
    flex-direction: column;
  }

  .user-avatar-section {
    width: 100%;
    height: 40vh;
  }

  .user-info-section {
    width: 100%;
    height: 40vh;
    padding: 2rem;
  }

  .notification-header {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }

  .user-avatar-large {
    width: min(60vw, 300px);
    height: min(60vw, 300px);
  }

  .notification-icon {
    width: clamp(60px, 12vw, 80px);
    height: clamp(60px, 12vw, 80px);
  }
}

/* ═══════════════════════════════════════════════════════════════
   ДОБАВЛЕНЫ В РЕФАКТОРИНГЕ — единые компоненты
   ═══════════════════════════════════════════════════════════════ */

/* ── PageHeader ─────────────────────────────────────────────── */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.page-header__title {
  color: var(--primary-orange);
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
}

.page-header__actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

/* ── DataTable ──────────────────────────────────────────────── */
/* СТАЛО: */
.data-table-wrap {
  overflow-x: scroll;          /* всегда показывает скроллбар */
  scrollbar-gutter: stable;    /* резервирует место под него */
  border-radius: 4px;
  border: 1px solid var(--border-light);
  box-shadow: var(--shadow-sm);
  background: var(--bg-primary);
}
body.dark-theme .data-table-wrap {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead th {
  background-color: var(--bg-surface);
  border-bottom: 2px solid var(--primary-orange);
  font-weight: 600;
  color: var(--text-primary);
  padding: 0.875rem 1rem;
  text-align: left;
  white-space: nowrap;
}

body.dark-theme .data-table thead th {
  background-color: var(--dark-bg-tertiary);
  color: var(--dark-text-primary);
}

.data-table tbody tr {
  border-bottom: 1px solid var(--border-light);
  transition: background-color var(--transition-fast);
}

body.dark-theme .data-table tbody tr {
  border-color: var(--border-dark);
}

.data-table tbody tr:last-child {
  border-bottom: none;
}

.data-table tbody tr:hover {
  background-color: var(--bg-surface);
}

body.dark-theme .data-table tbody tr:hover {
  background-color: var(--dark-bg-tertiary);
}

.data-table tbody td {
  padding: 0.875rem 1rem;
  vertical-align: middle;
  color: var(--text-secondary);
}

body.dark-theme .data-table tbody td {
  color: var(--dark-text-secondary);
}

.data-table-empty {
  padding: 2.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.95rem;
}

body.dark-theme .data-table-empty {
  color: var(--dark-text-muted);
}

/* ── Modal (базовый) ────────────────────────────────────────── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 1.5rem;
  cursor: pointer;
}

body.dark-theme .modal-overlay {
  background-color: rgba(0, 0, 0, 0.8);
}

.modal-box {
  background-color: var(--bg-primary);
  border-radius: 8px;
  padding: 2rem;
  position: relative;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  cursor: default;
}

body.dark-theme .modal-box {
  background-color: var(--dark-bg-secondary);
  border: 1px solid var(--border-dark);
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: var(--bg-tertiary);
  border: none;
  border-radius: 4px;
  width: 36px;
  height: 36px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.modal-close-btn:hover {
  background-color: var(--primary-orange);
  color: var(--text-inverse);
  transform: scale(1.05);
}

body.dark-theme .modal-close-btn {
  background: var(--dark-bg-tertiary);
  color: var(--dark-text-secondary);
}

.modal-title {
  color: var(--primary-orange);
  margin: 0 2.5rem 1rem 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.modal-subtitle {
  color: var(--text-muted);
  font-size: 0.85rem;
  margin-bottom: 1.5rem;
}

body.dark-theme .modal-subtitle {
  color: var(--dark-text-muted);
}

/* ── FileViewer ─────────────────────────────────────────────── */
.file-viewer-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 4rem 6rem 5rem;
  cursor: pointer;
}

.file-viewer-content {
  position: relative;
  max-width: 90vw;
  max-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}

.file-viewer__image {
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.7);
  -webkit-user-select: none;
          user-select: none;
}

.file-viewer__video {
  max-width: 100%;
  max-height: 85vh;
  border-radius: 8px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.7);
}

.file-viewer__audio-wrap {
  text-align: center;
  padding: 3rem;
  color: white;
}

.file-viewer__audio {
  width: 100%;
  max-width: 420px;
  margin-top: 1rem;
}

.file-viewer__filename {
  color: rgba(255,255,255,0.8);
  margin-top: 1rem;
}

.file-viewer__iframe {
  width: 80vw;
  height: 82vh;
  border: none;
  border-radius: 8px;
}

.file-viewer__big-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.file-viewer__unsupported {
  text-align: center;
  padding: 3rem;
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  border: 2px dashed rgba(255, 255, 255, 0.25);
  min-width: 320px;
}

.file-viewer__unsupported-name {
  color: white;
  margin-bottom: 0.75rem;
  font-size: 1.1rem;
}

.file-viewer__unsupported-hint {
  color: rgba(255,255,255,0.7);
  margin-bottom: 1.5rem;
}

.file-viewer__close {
  position: absolute;
  top: -44px;
  right: 0;
  background: rgba(255, 255, 255, 0.92);
  border: none;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  font-size: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  transition: all var(--transition-fast);
  box-shadow: 0 2px 10px rgba(0,0,0,0.4);
}

body.dark-theme .file-viewer__close {
  background: var(--dark-bg-secondary);
  color: var(--dark-text-primary);
  border: 1px solid var(--border-dark);
}

.file-viewer__close:hover {
  background: var(--primary-orange);
  color: white;
  transform: scale(1.1);
}

.file-viewer__nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.92);
  border: 2px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  width: 60px;
  height: 60px;
  font-size: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-weight: bold;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  transition: all var(--transition-fast);
  z-index: 1201;
}

body.dark-theme .file-viewer__nav {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
  color: var(--dark-text-primary);
}

.file-viewer__nav:hover:not(:disabled) {
  background: var(--primary-orange);
  color: white;
  border-color: var(--primary-orange-dark);
  transform: translateY(-50%) scale(1.08);
}

.file-viewer__nav:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.file-viewer__nav--prev { left: 1rem; }
.file-viewer__nav--next { right: 1rem; }

.file-viewer__counter {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.92);
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 0.625rem 1.25rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  white-space: nowrap;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 1201;
}

body.dark-theme .file-viewer__counter {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
  color: var(--dark-text-primary);
}

.file-viewer__counter-pos {
  display: block;
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.file-viewer__counter-name {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-orange);
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── AvatarCell ─────────────────────────────────────────────── */
.avatar-cell {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.avatar-cell__img {
  object-fit: cover;
  flex-shrink: 0;
}

.avatar-cell__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-orange);
  color: var(--text-inverse);
  font-weight: 700;
  flex-shrink: 0;
}

.avatar-cell__info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.avatar-cell__name {
  font-weight: 500;
  color: var(--text-primary);
}

body.dark-theme .avatar-cell__name {
  color: var(--dark-text-primary);
}

.avatar-cell__sub {
  font-size: 0.78rem;
  color: var(--text-muted);
}

body.dark-theme .avatar-cell__sub {
  color: var(--dark-text-muted);
}

/* ── Notification modal ─────────────────────────────────────── */
.notification-modal-header {
  margin-bottom: 1.25rem;
  padding-right: 2rem;
}

.notification-modal-title-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.notification-modal-date {
  font-size: 0.82rem;
  color: var(--text-muted);
  margin: 0;
}

body.dark-theme .notification-modal-date {
  color: var(--dark-text-muted);
}

.notification-modal-message {
  background: var(--bg-surface);
  border-left: 3px solid var(--primary-orange);
  padding: 1rem 1.25rem;
  border-radius: 0 4px 4px 0;
  margin-bottom: 1.5rem;
}

body.dark-theme .notification-modal-message {
  background: var(--dark-bg-tertiary);
}

.notification-modal-message p {
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.65;
}

.notification-modal-files-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

body.dark-theme .notification-modal-files-title {
  color: var(--dark-text-primary);
}

.notification-files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.notification-file-card {
  border: 1px solid var(--border-light);
  border-radius: 8px;
  overflow: hidden;
  transition: all var(--transition-fast);
  background: var(--bg-primary);
}

body.dark-theme .notification-file-card {
  background: var(--dark-bg-tertiary);
  border-color: var(--border-dark);
}

.notification-file-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.notification-file-preview {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: var(--bg-tertiary);
  overflow: hidden;
}

body.dark-theme .notification-file-preview {
  background: var(--dark-bg-secondary);
}

.notification-file-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.notification-file-preview-icon {
  font-size: 2.5rem;
}

.notification-file-info {
  padding: 0.75rem;
}

.notification-file-name {
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-primary);
  margin: 0 0 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

body.dark-theme .notification-file-name {
  color: var(--dark-text-primary);
}

.notification-file-meta {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin: 0 0 0.75rem;
}

/* ── gap utility ────────────────────────────────────────────── */
.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 1rem; }

/* ── btn-outline-primary / btn-outline-warning (missing aliases) */
.btn-outline-primary {
  background-color: transparent;
  color: var(--primary-orange);
  border: 1px solid var(--primary-orange);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-height: 44px;
}

.btn-outline-primary:hover {
  background-color: var(--primary-orange);
  color: var(--text-inverse);
}

.btn-outline-warning {
  background-color: transparent;
  color: var(--warning);
  border: 1px solid var(--warning);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-height: 44px;
}

.btn-outline-warning:hover {
  background-color: var(--warning);
  color: var(--text-inverse);
}

.ms-2 { margin-left: 0.5rem; }

/* ── Truncated text cell ────────────────────────────────────── */
.cell-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

/* ── Section card (внутри страницы) ────────────────────────── */
.section-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  padding: 1.5rem;
  box-shadow: var(--shadow-sm);
  margin-bottom: 1.5rem;
}

body.dark-theme .section-card {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.section-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  padding-bottom: 0.875rem;
  border-bottom: 1px solid var(--border-light);
}

body.dark-theme .section-card__header {
  border-color: var(--border-dark);
}

.section-card__title {
  color: var(--primary-orange);
  font-size: 1.15rem;
  font-weight: 600;
  margin: 0;
}

/* ── Expandable DataTable rows ──────────────────────────────── */
.data-table tbody tr.row-expandable {
  cursor: pointer;
}

.data-table tbody tr.row-expandable:hover {
  background-color: var(--bg-secondary);
}

body.dark-theme .data-table tbody tr.row-expandable:hover {
  background-color: var(--dark-bg-tertiary);
}

.data-table tbody tr.row-expanded {
  background-color: var(--bg-surface);
  border-bottom: none;
}

body.dark-theme .data-table tbody tr.row-expanded {
  background-color: var(--dark-bg-tertiary);
}

.expand-toggle-cell {
  text-align: center;
  padding: 0.875rem 0.5rem !important;
  color: var(--primary-orange);
  -webkit-user-select: none;
          user-select: none;
}

.expand-arrow {
  display: inline-block;
  font-size: 1.3rem;
  line-height: 1;
  font-weight: bold;
  transition: transform 0.18s ease;
  color: var(--primary-orange);
  opacity: 0.7;
}

.expand-arrow.expanded {
  transform: rotate(90deg);
  opacity: 1;
}

.data-table tbody tr.row-expandable:hover .expand-arrow {
  opacity: 1;
}

.expanded-content-row td {
  padding: 0 !important;
  border-bottom: 2px solid var(--primary-orange) !important;
}

.expanded-row-body {
  padding: 1rem 1.25rem 1rem 2.75rem;
  background-color: var(--bg-surface);
  border-left: 3px solid var(--primary-orange);
}

body.dark-theme .expanded-row-body {
  background-color: var(--dark-bg-surface);
}

/* Field label/value inside expanded row */
.exp-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-muted);
  margin-bottom: 2px;
}

body.dark-theme .exp-label {
  color: var(--dark-text-muted);
}

.exp-value {
  font-size: 0.875rem;
  color: var(--text-secondary);
  line-height: 1.45;
}

body.dark-theme .exp-value {
  color: var(--dark-text-secondary);
}

.exp-grid {
  display: grid;
  gap: 0.5rem 2rem;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
}

.exp-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-shrink: 0;
}

/* ── SidePanel ────────────────────────────────────────────── */
.side-panel-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1100;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.side-panel-overlay.visible {
  opacity: 1;
}

.side-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100dvh;
  max-width: 95vw;
  background: var(--bg-primary);
  border-left: 1px solid var(--border-light);
  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.18);
  z-index: 1101;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

body.dark-theme .side-panel {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.55);
}

.side-panel.open {
  transform: translateX(0);
}

.side-panel__header {
  padding: 1.25rem 1.5rem 1rem;
  border-bottom: 2px solid var(--primary-orange);
  flex-shrink: 0;
  background: var(--bg-surface);
}

body.dark-theme .side-panel__header {
  background: var(--dark-bg-tertiary);
}

.side-panel__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.side-panel__title {
  color: var(--primary-orange);
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
}

.side-panel__close {
  background: var(--bg-tertiary);
  border: none;
  border-radius: 4px;
  width: 36px;
  height: 36px;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.side-panel__close:hover {
  background: var(--primary-orange);
  color: white;
  transform: scale(1.05);
}

body.dark-theme .side-panel__close {
  background: var(--dark-bg-secondary);
  color: var(--dark-text-secondary);
}

.side-panel__nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.875rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border-light);
}

body.dark-theme .side-panel__nav {
  border-color: var(--border-dark);
}

.side-panel__nav-btn {
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  font-size: 1.4rem;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-orange);
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.side-panel__nav-btn:hover:not(:disabled) {
  background: var(--primary-orange);
  color: white;
  border-color: var(--primary-orange);
  transform: scale(1.05);
}

.side-panel__nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

body.dark-theme .side-panel__nav-btn {
  background: var(--dark-bg-secondary);
  border-color: var(--border-dark);
}

.side-panel__nav-label {
  flex: 1 1;
  text-align: center;
  font-size: 0.82rem;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

body.dark-theme .side-panel__nav-label {
  color: var(--dark-text-muted);
}

.side-panel__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem;
  scrollbar-gutter: stable;
}

.side-panel__body::-webkit-scrollbar { width: 6px; }
.side-panel__body::-webkit-scrollbar-track { background: var(--bg-tertiary); }
.side-panel__body::-webkit-scrollbar-thumb { background: var(--border-medium); border-radius: 3px; }

.side-panel__body .form-group:last-child { margin-bottom: 0; }

/* Footer with actions inside side panel body */
.side-panel__footer {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--border-light);
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

body.dark-theme .side-panel__footer {
  border-color: var(--border-dark);
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;;EAE/B,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;;EAEvB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;;EAE1B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;;EAE1B,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;;EAEtB,0CAA0C;EAC1C,yCAAyC;EACzC,4CAA4C;;EAE5C,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,qFAAqF;AACvF;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA,KAAK,iBAAiB,EAAE;AACxB,KAAK,eAAe,EAAE;AACtB,KAAK,kBAAkB,EAAE;AACzB,KAAK,iBAAiB,EAAE;AACxB,KAAK,kBAAkB,EAAE;AACzB,KAAK,eAAe,EAAE;;AAEtB;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,0BAA0B;EAC1B,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,YAAY;EACZ,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;EAEE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mDAAmD;EACnD,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf,kDAAkD;EAChD,mCAAmC;EACnC,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,WAAW;AACb;;AAEA,eAAe,0BAA0B,EAAE;AAC3C,eAAe,qCAAqC,EAAE;AACtD,eAAe,qCAAqC,EAAE;AACtD,eAAe,qCAAqC,EAAE;;AAEtD;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA,YAAY;AACZ,eAAe,kBAAkB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,cAAc,iBAAiB,EAAE;;AAEjC,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;;AAE7B,QAAQ,aAAa,EAAE;AACvB,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;;AAE1B,OAAO,UAAU,EAAE;AACnB,OAAO,gBAAgB,EAAE;AACzB,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;AACtB,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;;AAEtB,UAAU,aAAa,EAAE;AACzB,WAAW,cAAc,EAAE;AAC3B,UAAU,aAAa,EAAE;;AAEzB,2BAA2B,8BAA8B,EAAE;AAC3D,0BAA0B,uBAAuB,EAAE;AACnD,sBAAsB,mBAAmB,EAAE;;AAE3C,SAAS,WAAW,EAAE;AACtB,SAAS,YAAY,EAAE;;AAEvB,YAAY;AACZ;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mDAAmD;EACnD,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb,yBAAyB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sEAAwT;EACxT,8EAAgU;AAClU;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sEAAga;EACha,8EAAwa;AAC1a;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sEAAmQ;EACnQ,8EAA2Q;AAC7Q;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sEAAgS;EAChS,8EAAwS;AAC1S;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB,kDAAkD;EAChD,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,0BAA0B;EAC1B,kFAAkF;AACpF;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA,6CAA6C;AAC7C;;;;;;EAME,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,4DAA4D;AAC5D;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,sDAAsD;AACtD;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,+CAA+C;AAC/C;EACE,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;EAC/C,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,iDAAiD;EACjD,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,+CAA+C;EAC/C,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,qCAAqC;EACrC,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,4CAA4C;EAC5C,6BAA6B;EAC7B,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;EAC1C,0BAA0B;EAC1B,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,oBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,gDAAgD;EAChD,uBAAuB;EACvB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,oCAAoC;EACpC,uDAAuD;EACvD,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,kDAAkD;EAClD,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,iDAAiD;AACnD;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mFAAmF;EACnF,gBAAgB;AAClB;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mFAAmF;AACrF;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;AACF;;AAEA;;oEAEoE;;AAEpE,kEAAkE;AAClE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kEAAkE;AAClE,WAAW;AACX;EACE,kBAAkB,WAAW,gCAAgC;EAC7D,wBAAwB,KAAK,+BAA+B;EAC5D,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B,UAAU,EAAE;AACtC,0BAA0B,WAAW,EAAE;;AAEvC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,qBAAqB;EACrB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE,SAAS,YAAY,EAAE;AACvB,SAAS,WAAW,EAAE;AACtB,SAAS,SAAS,EAAE;;AAEpB,mEAAmE;AACnE;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,QAAQ,mBAAmB,EAAE;;AAE7B,kEAAkE;AAClE;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,uCAAuC,UAAU,EAAE;AACnD,6CAA6C,8BAA8B,EAAE;AAC7E,6CAA6C,gCAAgC,EAAE,kBAAkB,EAAE;;AAEnG,2CAA2C,gBAAgB,EAAE;;AAE7D,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[":root {\n  /* Основные цвета */\n  --primary-orange: #FF5722;\n  --primary-orange-dark: #E64A19;\n  --primary-orange-light: #FF8A65;\n\n  /* Текстовые цвета */\n  --text-primary: #212121;\n  --text-secondary: #424242;\n  --text-muted: #757575;\n  --text-inverse: #FFFFFF;\n\n  /* Фоновые цвета */\n  --bg-primary: #FFFFFF;\n  --bg-secondary: #F5F5F5;\n  --bg-tertiary: #EEEEEE;\n  --bg-surface: #FAFAFA;\n\n  /* Темная тема */\n  --dark-bg-primary: #121212;\n  --dark-bg-secondary: #1E1E1E;\n  --dark-bg-tertiary: #2D2D2D;\n  --dark-bg-surface: #262626;\n\n  --dark-text-primary: #FFFFFF;\n  --dark-text-secondary: #E0E0E0;\n  --dark-text-muted: #BDBDBD;\n\n  /* Акцентные цвета */\n  --success: #4CAF50;\n  --warning: #FF9800;\n  --error: #F44336;\n  --info: #2196F3;\n\n  /* Границы и тени */\n  --border-light: #E0E0E0;\n  --border-medium: #BDBDBD;\n  --border-dark: #757575;\n\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.12);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.15);\n\n  /* Переходы */\n  --transition-fast: 0.15s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  transition: background-color var(--transition-normal), color var(--transition-normal);\n}\n\nbody.dark-theme {\n  background-color: var(--dark-bg-primary);\n  color: var(--dark-text-primary);\n}\n\n/* Типографика */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  line-height: 1.3;\n  margin-bottom: 1rem;\n  color: var(--text-primary);\n}\n\nbody.dark-theme h1,\nbody.dark-theme h2,\nbody.dark-theme h3,\nbody.dark-theme h4,\nbody.dark-theme h5,\nbody.dark-theme h6 {\n  color: var(--dark-text-primary);\n}\n\nh1 { font-size: 2.5rem; }\nh2 { font-size: 2rem; }\nh3 { font-size: 1.75rem; }\nh4 { font-size: 1.5rem; }\nh5 { font-size: 1.25rem; }\nh6 { font-size: 1rem; }\n\np {\n  margin-bottom: 1rem;\n  color: var(--text-secondary);\n}\n\nbody.dark-theme p {\n  color: var(--dark-text-secondary);\n}\n\n/* Контейнеры */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  width: 100%;\n}\n\n.container-fluid {\n  width: 100%;\n  padding: 0 1.5rem;\n}\n\n/* Карточки */\n.card {\n  background-color: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: var(--shadow-sm);\n  transition: all var(--transition-normal);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-md);\n}\n\nbody.dark-theme .card {\n  background-color: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.card-header {\n  border-bottom: 1px solid var(--border-light);\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n}\n\nbody.dark-theme .card-header {\n  border-color: var(--border-dark);\n}\n\n/* Кнопки */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-height: 44px;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: var(--primary-orange);\n  color: var(--text-inverse);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--primary-orange-dark);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-secondary {\n  background-color: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-medium);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--primary-orange);\n  border: 1px solid var(--primary-orange);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background-color: var(--primary-orange);\n  color: var(--text-inverse);\n}\n\n.btn-success {\n  background-color: var(--success);\n  color: var(--text-inverse);\n}\n\n.btn-danger {\n  background-color: var(--error);\n  color: var(--text-inverse);\n}\n\n.btn-sm {\n  padding: 0.5rem 1rem;\n  font-size: 0.75rem;\n  min-height: 36px;\n}\n\n.btn-lg {\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  min-height: 52px;\n}\n\n/* Формы */\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\nbody.dark-theme .form-label {\n  color: var(--dark-text-primary);\n}\n\n.form-control {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: var(--primary-orange);\n  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.1);\n}\n\nbody.dark-theme .form-control {\n  background-color: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n  color: var(--dark-text-primary);\n}\n\nbody.dark-theme .form-control:focus {\n  border-color: var(--primary-orange);\n  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.2);\n}\n\nselect.form-control {\n  cursor: pointer;\n}\n\n/* Навигация */\n.navbar {\n  background-color: var(--bg-primary);\n  border-bottom: 1px solid var(--border-light);\n  padding: 0;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .navbar {\n  background-color: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.navbar-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 64px;\n}\n\n.navbar-brand {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--primary-orange);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.navbar-brand:hover {\n  color: var(--primary-orange-dark);\n}\n\n.navbar-nav {\n  display: flex;\n  list-style: none;\n  gap: 0.5rem;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  transition: all var(--transition-fast);\n  font-weight: 500;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  color: var(--primary-orange);\n  background-color: var(--bg-secondary);\n}\n\nbody.dark-theme .nav-link {\n  color: var(--dark-text-secondary);\n}\n\nbody.dark-theme .nav-link:hover,\nbody.dark-theme .nav-link.active {\n  color: var(--primary-orange);\n  background-color: var(--dark-bg-tertiary);\n}\n\n/* Выпадающие меню в навигации */\n.nav-dropdown {\n  position: relative;\n}\n\n.nav-dropdown > .nav-link {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.dropdown-arrow {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  transform: rotate(0deg);\n}\n\n.nav-dropdown:hover .dropdown-arrow {\n  transform: rotate(90deg);\n}\n\n.nav-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  box-shadow: var(--shadow-lg);\n  min-width: 200px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all var(--transition-fast);\n  z-index: 1001;\n  list-style: none;\n  margin: 0;\n}\n\nbody.dark-theme .nav-dropdown-menu {\n  background-color: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.nav-dropdown:hover .nav-dropdown-menu {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.nav-dropdown-menu .nav-link {\n  display: block;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 0;\n  white-space: nowrap;\n}\n\n.nav-dropdown-menu .nav-link:hover {\n  background-color: var(--bg-secondary);\n}\n\nbody.dark-theme .nav-dropdown-menu .nav-link:hover {\n  background-color: var(--dark-bg-tertiary);\n}\n\n/* Боковая панель */\n.sidebar {\n  background-color: var(--bg-primary);\n  border-right: 1px solid var(--border-light);\n  width: 280px;\n  min-height: calc(100vh - 64px);\n  padding: 1.5rem;\n}\n\nbody.dark-theme .sidebar {\n  background-color: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.sidebar-nav {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-item {\n  margin-bottom: 0.25rem;\n}\n\n.sidebar-link {\n  display: block;\n  padding: 0.75rem 1rem;\n  color: var(--text-secondary);\n  text-decoration: none;\n  border-radius: 4px;\n  transition: all var(--transition-fast);\n  font-weight: 500;\n}\n\n.sidebar-link:hover,\n.sidebar-link.active {\n  background-color: var(--primary-orange);\n  color: var(--text-inverse);\n}\n\nbody.dark-theme .sidebar-link {\n  color: var(--dark-text-secondary);\n}\n\n/* Основной контент */\n.main-content {\n  flex: 1;\n  padding: 1.5rem;\n}\n\n.layout {\n  display: flex;\n  min-height: calc(100vh - 64px);\n}\n\n/* Переключатель темы */\n.theme-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: background-color var(--transition-fast);\n  color: var(--text-secondary);\n}\n\n.theme-toggle:hover {\n  background-color: var(--bg-secondary);\n}\n\nbody.dark-theme .theme-toggle {\n  color: var(--dark-text-secondary);\n}\n\nbody.dark-theme .theme-toggle:hover {\n  background-color: var(--dark-bg-tertiary);\n}\n\n/* Аватары */\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  background-color: var(--bg-tertiary);\n}\n\n.avatar-large {\n  width: 100px;\n  height: 100px;\n}\n\n/* Прогресс бары */\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: var(--bg-tertiary);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background-color: var(--primary-orange);\n  transition: width var(--transition-normal);\n  border-radius: 4px;\n}\n\n/* Статусы */\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n}\n\n.status-pending {\n  background-color: var(--bg-tertiary);\n  color: var(--text-muted);\n}\n\n.status-submitted {\n  background-color: var(--primary-orange-light);\n  color: var(--text-inverse);\n}\n\n.status-approved {\n  background-color: var(--success);\n  color: var(--text-inverse);\n}\n\n.status-rejected {\n  background-color: var(--error);\n  color: var(--text-inverse);\n}\n\n/* Загрузка файлов */\n.file-upload {\n  border: 2px dashed var(--border-medium);\n  padding: 2rem;\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border-radius: 4px;\n  background-color: var(--bg-surface);\n}\n\n.file-upload:hover {\n  border-color: var(--primary-orange);\n  background-color: var(--bg-secondary);\n}\n\nbody.dark-theme .file-upload {\n  background-color: var(--dark-bg-surface);\n  border-color: var(--border-dark);\n}\n\nbody.dark-theme .file-upload:hover {\n  border-color: var(--primary-orange);\n  background-color: var(--dark-bg-tertiary);\n}\n\n/* Уведомления */\n.notification-item {\n  padding: 1rem;\n/*  border-left: 4px solid var(--primary-orange);*/\n  background-color: var(--bg-primary);\n  margin-bottom: 1rem;\n  border-radius: 0 4px 4px 0;\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .notification-item {\n  background-color: var(--dark-bg-secondary);\n}\n\n/* Скроллбары */\n.dashboard-scroll {\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n}\n\n.dashboard-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dashboard-scroll::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 4px;\n}\n\n.dashboard-scroll::-webkit-scrollbar-thumb {\n  background: var(--border-medium);\n  border-radius: 4px;\n}\n\n.dashboard-scroll::-webkit-scrollbar-thumb:hover {\n  background: var(--border-dark);\n}\n\nbody.dark-theme .dashboard-scroll::-webkit-scrollbar-track {\n  background: var(--dark-bg-tertiary);\n}\n\nbody.dark-theme .dashboard-scroll::-webkit-scrollbar-thumb {\n  background: var(--border-dark);\n}\n\n/* Карточки пользователей */\n.user-card {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  border: 1px solid var(--border-light);\n  margin-bottom: 0.75rem;\n  border-radius: 4px;\n  background-color: var(--bg-primary);\n  transition: all var(--transition-fast);\n}\n\n.user-card:hover {\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .user-card {\n  background-color: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.user-avatar {\n  margin-right: 1rem;\n  flex-shrink: 0;\n}\n\n.user-info h4 {\n  margin: 0 0 0.25rem 0;\n  color: var(--primary-orange);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.user-info p {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\nbody.dark-theme .user-info p {\n  color: var(--dark-text-muted);\n}\n\n/* Состояния */\n.loading {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-muted);\n}\n\n.error {\n  color: var(--error);\n  padding: 1rem;\n  border: 1px solid var(--error);\n  background-color: rgba(244, 67, 54, 0.1);\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\nbody.dark-theme .error {\n  background-color: rgba(244, 67, 54, 0.2);\n}\n\n.success {\n  color: var(--success);\n  padding: 1rem;\n  border: 1px solid var(--success);\n  background-color: rgba(76, 175, 80, 0.1);\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\nbody.dark-theme .success {\n  background-color: rgba(76, 175, 80, 0.2);\n}\n\n/* Сетка */\n.grid {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.grid-cols-1 { grid-template-columns: 1fr; }\n.grid-cols-2 { grid-template-columns: repeat(2, 1fr); }\n.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }\n.grid-cols-4 { grid-template-columns: repeat(4, 1fr); }\n\n@media (max-width: 768px) {\n  .grid-cols-2,\n  .grid-cols-3,\n  .grid-cols-4 {\n    grid-template-columns: 1fr;\n  }\n\n  .navbar-content {\n    padding: 0 1rem;\n  }\n\n  .container {\n    padding: 0 1rem;\n  }\n\n  .sidebar {\n    width: 100%;\n  }\n\n  .layout {\n    flex-direction: column;\n  }\n}\n\n/* Стили для таблицы должностей */\n.positions-table {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .positions-table {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.positions-table thead th {\n  background-color: var(--bg-surface);\n  border-bottom: 2px solid var(--primary-orange);\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: 1rem;\n  text-align: left;\n}\n\nbody.dark-theme .positions-table thead th {\n  background-color: var(--dark-bg-tertiary);\n  color: var(--dark-text-primary);\n}\n\n.positions-table tbody tr {\n  border-bottom: 1px solid var(--border-light);\n  transition: background-color var(--transition-fast);\n}\n\nbody.dark-theme .positions-table tbody tr {\n  border-color: var(--border-dark);\n}\n\n.positions-table tbody tr:hover {\n  background-color: var(--bg-surface);\n}\n\nbody.dark-theme .positions-table tbody tr:hover {\n  background-color: var(--dark-bg-tertiary);\n}\n\n.positions-table tbody td {\n  padding: 1rem;\n  vertical-align: middle;\n  color: var(--text-secondary);\n}\n\nbody.dark-theme .positions-table tbody td {\n  color: var(--dark-text-secondary);\n}\n\n.truncate-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n/* Иконки для кнопок */\n.fas {\n  font-size: 0.875rem;\n}\n\n/* Кнопки в таблице */\n.btn-sm {\n  font-size: 0.75rem;\n  font-weight: 500;\n  border-radius: 4px;\n  box-shadow: var(--shadow-sm);\n  transition: all var(--transition-fast);\n}\n\n.btn-sm:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Иконки в кнопках */\n.fas {\n  font-size: 0.75rem;\n}\n\n/* Стили для таблицы достижений */\n.achievements-table {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .achievements-table {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.achievements-table thead th {\n  background-color: var(--bg-surface);\n  border-bottom: 2px solid var(--primary-orange);\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: 1rem;\n  text-align: left;\n}\n\nbody.dark-theme .achievements-table thead th {\n  background-color: var(--dark-bg-tertiary);\n  color: var(--dark-text-primary);\n}\n\n.achievements-table tbody tr {\n  border-bottom: 1px solid var(--border-light);\n  transition: background-color var(--transition-fast);\n}\n\nbody.dark-theme .achievements-table tbody tr {\n  border-color: var(--border-dark);\n}\n\n.achievements-table tbody tr:hover {\n  background-color: var(--bg-surface);\n}\n\nbody.dark-theme .achievements-table tbody tr:hover {\n  background-color: var(--dark-bg-tertiary);\n}\n\n.achievements-table tbody td {\n  padding: 1rem;\n  vertical-align: middle;\n  color: var(--text-secondary);\n}\n\nbody.dark-theme .achievements-table tbody td {\n  color: var(--dark-text-secondary);\n}\n\n.achievements-table .truncate-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  cursor: help;\n}\n\n/* Утилиты */\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.mb-0 { margin-bottom: 0; }\n.mb-1 { margin-bottom: 0.25rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mb-3 { margin-bottom: 1rem; }\n.mb-4 { margin-bottom: 1.5rem; }\n.mb-5 { margin-bottom: 2rem; }\n\n.mt-0 { margin-top: 0; }\n.mt-1 { margin-top: 0.25rem; }\n.mt-2 { margin-top: 0.5rem; }\n.mt-3 { margin-top: 1rem; }\n.mt-4 { margin-top: 1.5rem; }\n.mt-5 { margin-top: 2rem; }\n\n.p-0 { padding: 0; }\n.p-1 { padding: 0.25rem; }\n.p-2 { padding: 0.5rem; }\n.p-3 { padding: 1rem; }\n.p-4 { padding: 1.5rem; }\n.p-5 { padding: 2rem; }\n\n.d-flex { display: flex; }\n.d-block { display: block; }\n.d-none { display: none; }\n\n.justify-content-between { justify-content: space-between; }\n.justify-content-center { justify-content: center; }\n.align-items-center { align-items: center; }\n\n.w-100 { width: 100%; }\n.h-100 { height: 100%; }\n\n/* Дашборд */\n.dashboard-content {\n  display: grid;\n  grid-template-columns: 1fr 350px;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n@media (max-width: 1024px) {\n  .dashboard-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dashboard-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.dashboard-section {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .dashboard-section {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-light);\n}\n\nbody.dark-theme .section-header {\n  border-color: var(--border-dark);\n}\n\n.section-header h2 {\n  color: var(--primary-orange);\n  margin: 0;\n  font-size: 1.5rem;\n}\n\n.view-all-button {\n  background: var(--primary-orange);\n  color: var(--text-inverse);\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.875rem;\n  transition: background-color var(--transition-fast);\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.view-all-button:hover {\n  background: var(--primary-orange-dark);\n  text-decoration: none;\n  color: var(--text-inverse);\n}\n\n/* Статистика дашборда */\n.dashboard-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n/*  margin-bottom: 3rem;*/\n}\n\n.stat-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  transition: all var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .stat-card {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.stat-icon {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-surface);\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\nbody.dark-theme .stat-icon {\n  background: var(--dark-bg-tertiary);\n}\n\n/* Иконки для статистики */\n.icon-chart::before {\n  content: \"\";\n  display: block;\n  width: 24px;\n  height: 24px;\n  background: var(--primary-orange);\n  mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cpath d='M3 3v18h18'/%3E%3Cpath d='m19 9-5 5-4-4-3 3'/%3E%3Cpath d='M14 12v8'/%3E%3Cpath d='M10 12v8'/%3E%3Cpath d='M6 12v8'/%3E%3C/svg%3E\") center/contain no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cpath d='M3 3v18h18'/%3E%3Cpath d='m19 9-5 5-4-4-3 3'/%3E%3Cpath d='M14 12v8'/%3E%3Cpath d='M10 12v8'/%3E%3Cpath d='M6 12v8'/%3E%3C/svg%3E\") center/contain no-repeat;\n}\n\n.icon-task::before {\n  content: \"\";\n  display: block;\n  width: 24px;\n  height: 24px;\n  background: var(--primary-orange);\n  mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cpath d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/%3E%3Cpolyline points='14 2 14 8 20 8'/%3E%3Cline x1='16' y1='13' x2='8' y2='13'/%3E%3Cline x1='16' y1='17' x2='8' y2='17'/%3E%3Cpolyline points='10 9 9 9 8 9'/%3E%3C/svg%3E\") center/contain no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cpath d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/%3E%3Cpolyline points='14 2 14 8 20 8'/%3E%3Cline x1='16' y1='13' x2='8' y2='13'/%3E%3Cline x1='16' y1='17' x2='8' y2='17'/%3E%3Cpolyline points='10 9 9 9 8 9'/%3E%3C/svg%3E\") center/contain no-repeat;\n}\n\n.icon-time::before {\n  content: \"\";\n  display: block;\n  width: 24px;\n  height: 24px;\n  background: var(--primary-orange);\n  mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpolyline points='12 6 12 12 16 14'/%3E%3C/svg%3E\") center/contain no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpolyline points='12 6 12 12 16 14'/%3E%3C/svg%3E\") center/contain no-repeat;\n}\n\n.icon-target::before {\n  content: \"\";\n  display: block;\n  width: 24px;\n  height: 24px;\n  background: var(--primary-orange);\n  mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Ccircle cx='12' cy='12' r='6'/%3E%3Ccircle cx='12' cy='12' r='2'/%3E%3C/svg%3E\") center/contain no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Ccircle cx='12' cy='12' r='6'/%3E%3Ccircle cx='12' cy='12' r='2'/%3E%3C/svg%3E\") center/contain no-repeat;\n}\n\n.stat-content h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--primary-orange);\n  margin: 0 0 0.25rem 0;\n}\n\n.stat-content p {\n  color: var(--text-muted);\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n/* Сетка достижений */\n.achievements-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n}\n\n.achievement-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-surface);\n  border-radius: 4px;\n  border: 1px solid var(--border-light);\n  transition: all var(--transition-fast);\n}\n\nbody.dark-theme .achievement-card {\n  background: var(--dark-bg-tertiary);\n  border-color: var(--border-dark);\n}\n\n.achievement-icon {\n  width: 50px;\n  height: 50px;\n  border-radius: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n}\n\nbody.dark-theme .achievement-icon {\n  background: var(--dark-bg-secondary);\n}\n\n.achievement-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.default-icon {\n  font-size: 1.5rem;\n}\n\n.default-achievement-icon {\n  width: 100%;\n  height: 100%;\n  background: var(--primary-orange);\n  color: var(--text-inverse);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 16px;\n  border-radius: 4px;\n}\n\n.achievement-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.achievement-info h4 {\n  color: var(--text-primary);\n  margin: 0 0 0.5rem 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\nbody.dark-theme .achievement-info h4 {\n  color: var(--dark-text-primary);\n}\n\n.progress-text {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n/* Список заданий */\n.tasks-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.task-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-surface);\n  border-radius: 4px;\n  border: 1px solid var(--border-light);\n  transition: all var(--transition-fast);\n  cursor: pointer;\n}\n\nbody.dark-theme .task-item {\n  background: var(--dark-bg-tertiary);\n  border-color: var(--border-dark);\n}\n\n.task-item:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.task-status {\n  flex-shrink: 0;\n}\n\n.task-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.task-content h4 {\n  color: var(--text-primary);\n  margin: 0 0 0.25rem 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\nbody.dark-theme .task-content h4 {\n  color: var(--dark-text-primary);\n}\n\n.task-date {\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  margin: 0;\n}\n\n/* Боковая панель дашборда */\n.dashboard-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.sidebar-section {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .sidebar-section {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.sidebar-section h3 {\n  color: var(--primary-orange);\n  margin: 0 0 1rem 0;\n  font-size: 1.25rem;\n}\n\n/* Список команды */\n.team-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.team-member {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: var(--bg-surface);\n  border-radius: 4px;\n  transition: all var(--transition-fast);\n}\n\nbody.dark-theme .team-member {\n  background: var(--dark-bg-tertiary);\n}\n\n.member-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.member-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  background: var(--primary-orange);\n  color: var(--text-inverse);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 0.875rem;\n  border-radius: 4px;\n}\n\n.member-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.member-info h4 {\n  color: var(--text-primary);\n  margin: 0 0 0.25rem 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\nbody.dark-theme .member-info h4 {\n  color: var(--dark-text-primary);\n}\n\n.member-info p {\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  margin: 0;\n}\n\n/* Список уведомлений */\n.notifications-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.notifications-list .notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: var(--bg-surface);\n  border-radius: 4px;\n/*  border-left: 3px solid var(--primary-orange);*/\n  transition: all var(--transition-fast);\n  cursor: pointer;\n}\n\n.notifications-list .notification-item:hover {\n  background: var(--bg-hover);\n  transform: translateX(2px);\n}\n\nbody.dark-theme .notifications-list .notification-item {\n  background: var(--dark-bg-tertiary);\n}\n\nbody.dark-theme .notifications-list .notification-item:hover {\n  background: var(--dark-bg-secondary);\n}\n\n.notification-type {\n  flex-shrink: 0;\n  margin-top: 0.25rem;\n}\n\n.notification-icon {\n  width: 24px;\n  height: 24px;\n  background: var(--primary-orange);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-inverse);\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.icon-profile::before {\n  content: \"П\";\n}\n\n.icon-info::before {\n  content: \"i\";\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-content h4 {\n  color: var(--text-primary);\n  margin: 0 0 0.25rem 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\nbody.dark-theme .notification-content h4 {\n  color: var(--dark-text-primary);\n}\n\n.notification-content p {\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  margin: 0 0 0.25rem 0;\n  line-height: 1.4;\n}\n\nbody.dark-theme .notification-content p {\n  color: var(--dark-text-secondary);\n}\n\n.notification-date {\n  color: var(--text-muted);\n  font-size: 0.625rem;\n  margin: 0;\n}\n\n/* Форма уведомлений */\n.notification-form {\n  margin-bottom: 2rem;\n}\n\n.notification-form .card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\nbody.dark-theme .notification-form .card {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.notification-form h3 {\n  color: var(--primary-orange);\n  margin: 0 0 1.5rem 0;\n  font-size: 1.25rem;\n}\n\n.notification-form .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.notification-form .form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\nbody.dark-theme .notification-form .form-label {\n  color: var(--dark-text-primary);\n}\n\n.notification-form .form-control {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\nbody.dark-theme .notification-form .form-control {\n  background-color: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n  color: var(--dark-text-primary);\n}\n\n.notification-form .form-control:focus {\n  outline: none;\n  border-color: var(--primary-orange);\n  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.1);\n}\n\n.notification-form textarea.form-control {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.notification-form .d-flex {\n  display: flex;\n}\n\n.notification-form .gap-2 {\n  gap: 0.5rem;\n}\n\n.notification-form .justify-content-end {\n  justify-content: flex-end;\n}\n\n.notification-form .mt-3 {\n  margin-top: 1rem;\n}\n\n/* Страница администрирования уведомлений */\n.notifications-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.notification-item-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  padding: 1rem;\n  box-shadow: var(--shadow-sm);\n  transition: all var(--transition-fast);\n}\n\nbody.dark-theme .notification-item-card {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.notification-item-card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--border-light);\n}\n\nbody.dark-theme .notification-header {\n  border-color: var(--border-dark);\n}\n\n.notification-type-badge {\n  background: var(--primary-orange);\n  color: var(--text-inverse);\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.notification-date {\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\n.notification-content h4 {\n  color: var(--primary-orange);\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\nbody.dark-theme .notification-content h4 {\n  color: var(--primary-orange);\n}\n\n.notification-content p {\n  color: var(--text-secondary);\n  margin: 0 0 1rem 0;\n  line-height: 1.5;\n}\n\nbody.dark-theme .notification-content p {\n  color: var(--dark-text-secondary);\n}\n\n.notification-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.notification-files {\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--border-light);\n}\n\n.file-item {\n  margin: 0.25rem 0;\n}\n\n.file-link {\n  display: inline-flex;\n  align-items: center;\n  color: var(--primary-blue);\n  text-decoration: none;\n  font-size: 0.875rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.file-link:hover {\n  background-color: var(--bg-hover);\n  text-decoration: underline;\n}\n\n.btn-sm {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.75rem;\n}\n\n/* Модальные окна */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  cursor: pointer;\n  padding: 2rem;\n  overflow-y: auto;\n}\n\n.modal-content {\n  position: relative;\n  background-color: var(--bg-surface);\n  border-radius: 4px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  max-width: 95vw;\n  max-height: 95vh;\n  overflow: hidden;\n}\n\n/* Улучшенная темная тема для модальных окон */\nbody.dark-theme .modal-overlay {\n  background-color: rgba(0, 0, 0, 0.95);\n}\n\nbody.dark-theme .modal-content {\n  background-color: var(--dark-bg-surface);\n  border: 1px solid var(--border-dark);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);\n}\n\n/* Темная тема для текста в модальных окнах */\nbody.dark-theme .modal-content h1,\nbody.dark-theme .modal-content h2,\nbody.dark-theme .modal-content h3,\nbody.dark-theme .modal-content h4,\nbody.dark-theme .modal-content h5,\nbody.dark-theme .modal-content h6 {\n  color: var(--dark-text-primary);\n}\n\nbody.dark-theme .modal-content p,\nbody.dark-theme .modal-content div {\n  color: var(--dark-text-secondary);\n}\n\nbody.dark-theme .modal-content strong {\n  color: var(--dark-text-primary);\n}\n\n/* Темная тема для заголовков модальных окон */\nbody.dark-theme .modal-header {\n  background-color: var(--dark-bg-secondary);\n  border-bottom: 1px solid var(--border-dark);\n}\n\nbody.dark-theme .modal-header h2,\nbody.dark-theme .modal-header h3 {\n  color: var(--primary-orange);\n}\n\n/* Темная тема для информационных блоков в модальных окнах */\nbody.dark-theme .modal-info-section {\n  background-color: var(--dark-bg-secondary);\n  border: 1px solid var(--border-dark);\n}\n\nbody.dark-theme .modal-info-section .info-label {\n  color: var(--dark-text-muted);\n}\n\nbody.dark-theme .modal-info-section .info-value {\n  color: var(--dark-text-primary);\n}\n\n/* Темная тема для кнопок в модальных окнах */\nbody.dark-theme .modal-overlay button {\n  background: var(--dark-bg-secondary);\n  color: var(--dark-text-primary);\n  border: 1px solid var(--border-dark);\n}\n\nbody.dark-theme .modal-overlay button:hover {\n  background: var(--dark-bg-tertiary);\n  border-color: var(--primary-orange);\n}\n\n/* Темная тема для кнопок действий в модальных окнах */\nbody.dark-theme .modal-action-btn {\n  background: var(--dark-bg-secondary);\n  color: var(--dark-text-primary);\n  border: 1px solid var(--border-dark);\n}\n\nbody.dark-theme .modal-action-btn:hover {\n  background: var(--dark-bg-tertiary);\n  border-color: var(--primary-orange);\n}\n\nbody.dark-theme .modal-action-btn.approve {\n  background: var(--primary-orange);\n  color: white;\n  border-color: var(--primary-orange);\n}\n\nbody.dark-theme .modal-action-btn.approve:hover {\n  background: var(--primary-orange-dark);\n  border-color: var(--primary-orange-dark);\n}\n\nbody.dark-theme .modal-action-btn.reject {\n  background: #F44336;\n  color: white;\n  border-color: #F44336;\n}\n\nbody.dark-theme .modal-action-btn.reject:hover {\n  background: #D32F2F;\n  border-color: #D32F2F;\n}\n\n/* Темная тема для форм в модальных окнах */\nbody.dark-theme .modal-form textarea {\n  background-color: var(--dark-bg-secondary);\n  border: 1px solid var(--border-dark);\n  color: var(--dark-text-primary);\n}\n\nbody.dark-theme .modal-form textarea:focus {\n  border-color: var(--primary-orange);\n  box-shadow: 0 0 0 2px rgba(230, 74, 25, 0.2);\n}\n\nbody.dark-theme .modal-form label {\n  color: var(--dark-text-primary);\n}\n\n/* Темная тема для статусов в модальных окнах */\nbody.dark-theme .modal-status-badge {\n  background-color: var(--dark-bg-tertiary);\n  color: var(--dark-text-secondary);\n  border: 1px solid var(--border-dark);\n}\n\nbody.dark-theme .modal-status-badge.status-pending {\n  background-color: rgba(255, 152, 0, 0.2);\n  color: #FF9800;\n  border-color: #FF9800;\n}\n\nbody.dark-theme .modal-status-badge.status-submitted {\n  background-color: rgba(33, 150, 243, 0.2);\n  color: #2196F3;\n  border-color: #2196F3;\n}\n\nbody.dark-theme .modal-status-badge.status-approved {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #4CAF50;\n  border-color: #4CAF50;\n}\n\nbody.dark-theme .modal-status-badge.status-rejected {\n  background-color: rgba(244, 67, 54, 0.2);\n  color: #F44336;\n  border-color: #F44336;\n}\n\n/* Темная тема для файлов в модальных окнах */\nbody.dark-theme .modal-file-item {\n  background-color: var(--dark-bg-secondary);\n  border: 1px solid var(--border-dark);\n}\n\nbody.dark-theme .modal-file-item:hover {\n  background-color: var(--dark-bg-tertiary);\n  border-color: var(--primary-orange);\n}\n\nbody.dark-theme .modal-file-item .file-name {\n  color: var(--dark-text-primary);\n}\n\nbody.dark-theme .modal-file-item .file-type {\n  color: var(--dark-text-muted);\n}\n\n/* Стили для модального окна уведомлений */\n.notification-modal-overlay {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  background-color: rgba(0, 0, 0, 0.7) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  z-index: 1000 !important;\n  padding: 2rem !important;\n}\n\nbody.dark-theme .notification-modal-overlay {\n  background-color: rgba(0, 0, 0, 0.9) !important;\n}\n\n.notification-modal-content {\n  background-color: var(--bg-surface) !important;\n  border-radius: 4px !important;\n  padding: 2rem !important;\n  max-width: 900px !important;\n  width: 95% !important;\n  max-height: 90vh !important;\n  overflow-y: auto !important;\n  position: relative !important;\n  border: 1px solid var(--border-medium) !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;\n}\n\nbody.dark-theme .notification-modal-content {\n  background-color: var(--dark-bg-surface) !important;\n  border-color: var(--border-dark) !important;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8) !important;\n}\n\n.notification-modal-close {\n  position: absolute !important;\n  top: 1rem !important;\n  right: 1rem !important;\n  background: rgba(255, 255, 255, 0.9) !important;\n  border: none !important;\n  border-radius: 4px !important;\n  width: 36px !important;\n  height: 36px !important;\n  font-size: 20px !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: var(--text-primary) !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\n  transition: all 0.2s ease !important;\n}\n\nbody.dark-theme .notification-modal-close {\n  background: var(--dark-bg-secondary) !important;\n  color: var(--dark-text-primary) !important;\n  border: 1px solid var(--border-dark) !important;\n}\n\n.notification-modal-close:hover {\n  background: var(--primary-orange) !important;\n  color: white !important;\n}\n\n.notification-modal-header {\n  margin-bottom: 2rem !important;\n}\n\n.notification-modal-title-row {\n  display: flex !important;\n  align-items: center !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.notification-modal-title-row .notification-icon {\n  margin-right: 1rem !important;\n  width: 32px !important;\n  height: 32px !important;\n}\n\n.notification-modal-title {\n  margin: 0 !important;\n  color: var(--primary-orange) !important;\n  font-size: 1.75rem !important;\n  font-weight: 600 !important;\n}\n\nbody.dark-theme .notification-modal-title {\n  color: var(--primary-orange) !important;\n}\n\n.notification-modal-date {\n  margin: 0 !important;\n  color: var(--text-muted) !important;\n  font-size: 0.9rem !important;\n}\n\nbody.dark-theme .notification-modal-date {\n  color: var(--dark-text-muted) !important;\n}\n\n.notification-modal-message {\n  margin-bottom: 2rem !important;\n}\n\n.notification-modal-message p {\n  margin: 0 !important;\n  line-height: 1.7 !important;\n  color: var(--text-primary) !important;\n  font-size: 1.05rem !important;\n  white-space: pre-wrap !important;\n}\n\nbody.dark-theme .notification-modal-message p {\n  color: var(--dark-text-primary) !important;\n}\n\n.notification-modal-files {\n  margin-top: 1rem !important;\n}\n\n.notification-modal-files-title {\n  margin-bottom: 1.5rem !important;\n  color: var(--text-primary) !important;\n  font-size: 1.25rem !important;\n  font-weight: 600 !important;\n}\n\nbody.dark-theme .notification-modal-files-title {\n  color: var(--dark-text-primary) !important;\n}\n\n.notification-modal-files-grid {\n  display: grid !important;\n  gap: 1rem !important;\n}\n\n.notification-modal-file-item {\n  display: flex !important;\n  align-items: center !important;\n  padding: 1rem !important;\n  background-color: var(--bg-hover) !important;\n  border-radius: 4px !important;\n  border: 1px solid var(--border-light) !important;\n  transition: all 0.2s ease !important;\n}\n\nbody.dark-theme .notification-modal-file-item {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--border-dark) !important;\n}\n\n.notification-modal-file-item:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n}\n\nbody.dark-theme .notification-modal-file-item:hover {\n  background-color: var(--dark-bg-tertiary) !important;\n  border-color: var(--primary-orange) !important;\n}\n\n.notification-modal-file-preview {\n  width: 80px !important;\n  height: 80px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 4px !important;\n  margin-right: 1.5rem !important;\n  cursor: pointer !important;\n  transition: transform 0.2s ease !important;\n  font-size: 2rem !important;\n  background-color: var(--primary-blue) !important;\n  color: white !important;\n}\n\n.notification-modal-file-preview:hover {\n  transform: scale(1.05) !important;\n}\n\n.notification-modal-file-image {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  border-radius: 4px !important;\n}\n\n.notification-modal-file-icon {\n  width: 100% !important;\n  height: 100% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 2rem !important;\n}\n\n.notification-modal-file-info {\n  flex: 1 !important;\n}\n\n.notification-modal-file-name {\n  margin: 0 0 0.25rem 0 !important;\n  font-weight: 600 !important;\n  color: var(--text-primary) !important;\n  font-size: 1.05rem !important;\n}\n\nbody.dark-theme .notification-modal-file-name {\n  color: var(--dark-text-primary) !important;\n}\n\n.notification-modal-file-details {\n  margin: 0 !important;\n  font-size: 0.9rem !important;\n  color: var(--text-muted) !important;\n}\n\nbody.dark-theme .notification-modal-file-details {\n  color: var(--dark-text-muted) !important;\n}\n\n.notification-modal-file-actions {\n  display: flex !important;\n  gap: 0.75rem !important;\n}\n\n.notification-modal-file-link {\n  padding: 0.75rem 1.25rem !important;\n  background-color: var(--primary-blue) !important;\n  color: black !important;\n  text-decoration: none !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  font-size: 0.9rem !important;\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3) !important;\n  display: inline-block !important;\n}\n\nbody.dark-theme .notification-modal-file-link {\n  color: white !important;\n}\n\n.notification-modal-file-link:hover {\n  background-color: #1e40af !important;\n  transform: translateY(-1px) !important;\n  text-decoration: none !important;\n  color: white !important;\n}\n\n.notification-modal-download-btn {\n  padding: 0.75rem 1.25rem !important;\n  background-color: var(--primary-orange) !important;\n  color: black !important;\n  border: none !important;\n  border-radius: 4px !important;\n  font-size: 0.9rem !important;\n  font-weight: 500 !important;\n  display: inline-block !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 2px 4px rgba(251, 146, 60, 0.3) !important;\n  cursor: pointer !important;\n}\n\nbody.dark-theme .notification-modal-download-btn {\n  color: white !important;\n}\n\n.notification-modal-download-btn:hover {\n  background-color: #ea580c !important;\n  transform: translateY(-1px) !important;\n  color: white !important;\n}\n\n.modal-overlay button {\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  border-radius: 4px;\n  color: var(--text-primary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\nbody.dark-theme .modal-overlay button {\n  background: var(--dark-bg-secondary);\n  color: var(--dark-text-primary);\n  border: 1px solid var(--border-dark);\n}\n\n.modal-overlay button:hover {\n  transform: scale(1.05);\n}\n\n.modal-overlay button:active {\n  transform: scale(0.95);\n}\n@media (max-width: 768px) {\n  .dashboard-content {\n    margin-top: 1rem;\n  }\n\n  .dashboard-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n\n  .stat-card {\n    padding: 1rem;\n  }\n\n  .stat-icon {\n    width: 50px;\n    height: 50px;\n  }\n\n  .stat-content h3 {\n    font-size: 1.5rem;\n  }\n\n  .achievements-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .achievement-card {\n    padding: 0.75rem;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n}\n.public-dashboard {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: var(--bg-primary);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.dark-theme .public-dashboard {\n  background: var(--dark-bg-primary);\n}\n\n.dashboard-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.public-dashboard-card {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Экран загрузки */\n.loading-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 2rem;\n}\n\n.loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid var(--border-light);\n  border-top: 4px solid var(--primary-orange);\n  border-radius: 4px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Анимации перехода */\n.slide-enter {\n  transform: translateX(100%);\n  opacity: 0;\n}\n\n.slide-enter-active {\n  transform: translateX(0);\n  opacity: 1;\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.slide-exit {\n  transform: translateX(0);\n  opacity: 1;\n}\n\n.slide-exit-active {\n  transform: translateX(-100%);\n  opacity: 0;\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Карточка пользователя */\n.user-showcase {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.user-avatar-section {\n  width: 50%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--bg-surface) 0%, var(--bg-secondary) 100%);\n  overflow: hidden;\n}\n\nbody.dark-theme .user-avatar-section {\n  background: linear-gradient(135deg, var(--dark-bg-tertiary) 0%, var(--dark-bg-secondary) 100%);\n}\n\n.user-avatar-large {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.user-avatar-large[style] {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-inverse);\n  font-weight: bold;\n  font-size: clamp(6rem, 15vw, 12rem);\n}\n\n.user-info-section {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 4rem;\n}\n\n.user-name {\n  font-size: clamp(2.5rem, 6vw, 4rem);\n  font-weight: 700;\n  color: var(--primary-orange);\n  margin: 0 0 2rem 0;\n  line-height: 1.1;\n}\n\n.user-details {\n  font-size: clamp(1.2rem, 3vw, 2rem);\n  color: var(--text-secondary);\n  margin: 1rem 0;\n}\n\nbody.dark-theme .user-details {\n  color: var(--dark-text-secondary);\n}\n\n.role-badge {\n  display: inline-block;\n  padding: 1rem 2rem;\n  border-radius: 0;\n  font-weight: 600;\n  font-size: clamp(1rem, 2.5vw, 1.5rem);\n  margin-top: 2rem;\n  background: var(--primary-orange);\n  color: var(--text-inverse);\n}\n\n.notification-message-content {\n  margin-top: 2rem;\n}\n\n.notification-message-content .notification-message {\n  font-size: clamp(1.2rem, 3vw, 1.8rem);\n  line-height: 1.4;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\nbody.dark-theme .notification-message-content .notification-message {\n  color: var(--dark-text-secondary);\n}\n\n/* Карточка уведомления */\n.notification-card {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 4rem;\n  background: linear-gradient(135deg, var(--bg-surface) 0%, var(--bg-secondary) 100%);\n}\n\nbody.dark-theme .notification-card {\n  background: linear-gradient(135deg, var(--dark-bg-tertiary) 0%, var(--dark-bg-secondary) 100%);\n}\n\n.notification-header {\n  display: flex;\n  align-items: center;\n  gap: 3rem;\n  margin-bottom: 3rem;\n}\n\n.notification-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n  font-weight: bold;\n  color: var(--text-inverse);\n  flex-shrink: 0;\n}\n\n.icon-profile {\n  background: var(--primary-orange);\n}\n\n.icon-info {\n  background: var(--info);\n}\n\n.notification-title h2 {\n  margin: 0 0 1rem 0;\n  color: var(--text-primary);\n  font-size: clamp(2rem, 5vw, 3.5rem);\n  text-align: center;\n}\n\nbody.dark-theme .notification-title h2 {\n  color: var(--dark-text-primary);\n}\n\n.notification-date {\n  margin: 0;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.notification-content {\n  text-align: center;\n  max-width: 800px;\n}\n\n.notification-message {\n  font-size: clamp(1.5rem, 4vw, 2.5rem);\n  line-height: 1.4;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\nbody.dark-theme .notification-message {\n  color: var(--dark-text-secondary);\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .user-showcase {\n    flex-direction: column;\n  }\n\n  .user-avatar-section {\n    width: 100%;\n    height: 40vh;\n  }\n\n  .user-info-section {\n    width: 100%;\n    height: 40vh;\n    padding: 2rem;\n  }\n\n  .notification-header {\n    flex-direction: column;\n    gap: 2rem;\n    text-align: center;\n  }\n\n  .user-avatar-large {\n    width: min(60vw, 300px);\n    height: min(60vw, 300px);\n  }\n\n  .notification-icon {\n    width: clamp(60px, 12vw, 80px);\n    height: clamp(60px, 12vw, 80px);\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   ДОБАВЛЕНЫ В РЕФАКТОРИНГЕ — единые компоненты\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── PageHeader ─────────────────────────────────────────────── */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.page-header__title {\n  color: var(--primary-orange);\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n}\n\n.page-header__actions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* ── DataTable ──────────────────────────────────────────────── */\n/* СТАЛО: */\n.data-table-wrap {\n  overflow-x: scroll;          /* всегда показывает скроллбар */\n  scrollbar-gutter: stable;    /* резервирует место под него */\n  border-radius: 4px;\n  border: 1px solid var(--border-light);\n  box-shadow: var(--shadow-sm);\n  background: var(--bg-primary);\n}\nbody.dark-theme .data-table-wrap {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table thead th {\n  background-color: var(--bg-surface);\n  border-bottom: 2px solid var(--primary-orange);\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: 0.875rem 1rem;\n  text-align: left;\n  white-space: nowrap;\n}\n\nbody.dark-theme .data-table thead th {\n  background-color: var(--dark-bg-tertiary);\n  color: var(--dark-text-primary);\n}\n\n.data-table tbody tr {\n  border-bottom: 1px solid var(--border-light);\n  transition: background-color var(--transition-fast);\n}\n\nbody.dark-theme .data-table tbody tr {\n  border-color: var(--border-dark);\n}\n\n.data-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.data-table tbody tr:hover {\n  background-color: var(--bg-surface);\n}\n\nbody.dark-theme .data-table tbody tr:hover {\n  background-color: var(--dark-bg-tertiary);\n}\n\n.data-table tbody td {\n  padding: 0.875rem 1rem;\n  vertical-align: middle;\n  color: var(--text-secondary);\n}\n\nbody.dark-theme .data-table tbody td {\n  color: var(--dark-text-secondary);\n}\n\n.data-table-empty {\n  padding: 2.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\nbody.dark-theme .data-table-empty {\n  color: var(--dark-text-muted);\n}\n\n/* ── Modal (базовый) ────────────────────────────────────────── */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n  padding: 1.5rem;\n  cursor: pointer;\n}\n\nbody.dark-theme .modal-overlay {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.modal-box {\n  background-color: var(--bg-primary);\n  border-radius: 8px;\n  padding: 2rem;\n  position: relative;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  cursor: default;\n}\n\nbody.dark-theme .modal-box {\n  background-color: var(--dark-bg-secondary);\n  border: 1px solid var(--border-dark);\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: var(--bg-tertiary);\n  border: none;\n  border-radius: 4px;\n  width: 36px;\n  height: 36px;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.modal-close-btn:hover {\n  background-color: var(--primary-orange);\n  color: var(--text-inverse);\n  transform: scale(1.05);\n}\n\nbody.dark-theme .modal-close-btn {\n  background: var(--dark-bg-tertiary);\n  color: var(--dark-text-secondary);\n}\n\n.modal-title {\n  color: var(--primary-orange);\n  margin: 0 2.5rem 1rem 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.modal-subtitle {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n  margin-bottom: 1.5rem;\n}\n\nbody.dark-theme .modal-subtitle {\n  color: var(--dark-text-muted);\n}\n\n/* ── FileViewer ─────────────────────────────────────────────── */\n.file-viewer-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1200;\n  padding: 4rem 6rem 5rem;\n  cursor: pointer;\n}\n\n.file-viewer-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 85vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: default;\n}\n\n.file-viewer__image {\n  max-width: 100%;\n  max-height: 85vh;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.7);\n  user-select: none;\n}\n\n.file-viewer__video {\n  max-width: 100%;\n  max-height: 85vh;\n  border-radius: 8px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.7);\n}\n\n.file-viewer__audio-wrap {\n  text-align: center;\n  padding: 3rem;\n  color: white;\n}\n\n.file-viewer__audio {\n  width: 100%;\n  max-width: 420px;\n  margin-top: 1rem;\n}\n\n.file-viewer__filename {\n  color: rgba(255,255,255,0.8);\n  margin-top: 1rem;\n}\n\n.file-viewer__iframe {\n  width: 80vw;\n  height: 82vh;\n  border: none;\n  border-radius: 8px;\n}\n\n.file-viewer__big-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.file-viewer__unsupported {\n  text-align: center;\n  padding: 3rem;\n  color: white;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  border: 2px dashed rgba(255, 255, 255, 0.25);\n  min-width: 320px;\n}\n\n.file-viewer__unsupported-name {\n  color: white;\n  margin-bottom: 0.75rem;\n  font-size: 1.1rem;\n}\n\n.file-viewer__unsupported-hint {\n  color: rgba(255,255,255,0.7);\n  margin-bottom: 1.5rem;\n}\n\n.file-viewer__close {\n  position: absolute;\n  top: -44px;\n  right: 0;\n  background: rgba(255, 255, 255, 0.92);\n  border: none;\n  border-radius: 4px;\n  width: 40px;\n  height: 40px;\n  font-size: 22px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n  transition: all var(--transition-fast);\n  box-shadow: 0 2px 10px rgba(0,0,0,0.4);\n}\n\nbody.dark-theme .file-viewer__close {\n  background: var(--dark-bg-secondary);\n  color: var(--dark-text-primary);\n  border: 1px solid var(--border-dark);\n}\n\n.file-viewer__close:hover {\n  background: var(--primary-orange);\n  color: white;\n  transform: scale(1.1);\n}\n\n.file-viewer__nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.92);\n  border: 2px solid rgba(0, 0, 0, 0.25);\n  border-radius: 4px;\n  width: 60px;\n  height: 60px;\n  font-size: 32px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n  font-weight: bold;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.5);\n  transition: all var(--transition-fast);\n  z-index: 1201;\n}\n\nbody.dark-theme .file-viewer__nav {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n  color: var(--dark-text-primary);\n}\n\n.file-viewer__nav:hover:not(:disabled) {\n  background: var(--primary-orange);\n  color: white;\n  border-color: var(--primary-orange-dark);\n  transform: translateY(-50%) scale(1.08);\n}\n\n.file-viewer__nav:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.file-viewer__nav--prev { left: 1rem; }\n.file-viewer__nav--next { right: 1rem; }\n\n.file-viewer__counter {\n  position: absolute;\n  bottom: 1rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(255, 255, 255, 0.92);\n  border: 2px solid rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  padding: 0.625rem 1.25rem;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.5);\n  white-space: nowrap;\n  max-width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  z-index: 1201;\n}\n\nbody.dark-theme .file-viewer__counter {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n  color: var(--dark-text-primary);\n}\n\n.file-viewer__counter-pos {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.file-viewer__counter-name {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--primary-orange);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── AvatarCell ─────────────────────────────────────────────── */\n.avatar-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.avatar-cell__img {\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.avatar-cell__placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--primary-orange);\n  color: var(--text-inverse);\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.avatar-cell__info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.avatar-cell__name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\nbody.dark-theme .avatar-cell__name {\n  color: var(--dark-text-primary);\n}\n\n.avatar-cell__sub {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n\nbody.dark-theme .avatar-cell__sub {\n  color: var(--dark-text-muted);\n}\n\n/* ── Notification modal ─────────────────────────────────────── */\n.notification-modal-header {\n  margin-bottom: 1.25rem;\n  padding-right: 2rem;\n}\n\n.notification-modal-title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.notification-modal-date {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\nbody.dark-theme .notification-modal-date {\n  color: var(--dark-text-muted);\n}\n\n.notification-modal-message {\n  background: var(--bg-surface);\n  border-left: 3px solid var(--primary-orange);\n  padding: 1rem 1.25rem;\n  border-radius: 0 4px 4px 0;\n  margin-bottom: 1.5rem;\n}\n\nbody.dark-theme .notification-modal-message {\n  background: var(--dark-bg-tertiary);\n}\n\n.notification-modal-message p {\n  margin: 0;\n  white-space: pre-wrap;\n  line-height: 1.65;\n}\n\n.notification-modal-files-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 1rem;\n}\n\nbody.dark-theme .notification-modal-files-title {\n  color: var(--dark-text-primary);\n}\n\n.notification-files-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.notification-file-card {\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all var(--transition-fast);\n  background: var(--bg-primary);\n}\n\nbody.dark-theme .notification-file-card {\n  background: var(--dark-bg-tertiary);\n  border-color: var(--border-dark);\n}\n\n.notification-file-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.notification-file-preview {\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background: var(--bg-tertiary);\n  overflow: hidden;\n}\n\nbody.dark-theme .notification-file-preview {\n  background: var(--dark-bg-secondary);\n}\n\n.notification-file-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.notification-file-preview-icon {\n  font-size: 2.5rem;\n}\n\n.notification-file-info {\n  padding: 0.75rem;\n}\n\n.notification-file-name {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin: 0 0 0.25rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nbody.dark-theme .notification-file-name {\n  color: var(--dark-text-primary);\n}\n\n.notification-file-meta {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin: 0 0 0.75rem;\n}\n\n/* ── gap utility ────────────────────────────────────────────── */\n.gap-1 { gap: 0.25rem; }\n.gap-2 { gap: 0.5rem; }\n.gap-3 { gap: 1rem; }\n\n/* ── btn-outline-primary / btn-outline-warning (missing aliases) */\n.btn-outline-primary {\n  background-color: transparent;\n  color: var(--primary-orange);\n  border: 1px solid var(--primary-orange);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1.5rem;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-height: 44px;\n}\n\n.btn-outline-primary:hover {\n  background-color: var(--primary-orange);\n  color: var(--text-inverse);\n}\n\n.btn-outline-warning {\n  background-color: transparent;\n  color: var(--warning);\n  border: 1px solid var(--warning);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1.5rem;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-height: 44px;\n}\n\n.btn-outline-warning:hover {\n  background-color: var(--warning);\n  color: var(--text-inverse);\n}\n\n.ms-2 { margin-left: 0.5rem; }\n\n/* ── Truncated text cell ────────────────────────────────────── */\n.cell-truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 180px;\n}\n\n/* ── Section card (внутри страницы) ────────────────────────── */\n.section-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 1.5rem;\n}\n\nbody.dark-theme .section-card {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.section-card__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.25rem;\n  padding-bottom: 0.875rem;\n  border-bottom: 1px solid var(--border-light);\n}\n\nbody.dark-theme .section-card__header {\n  border-color: var(--border-dark);\n}\n\n.section-card__title {\n  color: var(--primary-orange);\n  font-size: 1.15rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* ── Expandable DataTable rows ──────────────────────────────── */\n.data-table tbody tr.row-expandable {\n  cursor: pointer;\n}\n\n.data-table tbody tr.row-expandable:hover {\n  background-color: var(--bg-secondary);\n}\n\nbody.dark-theme .data-table tbody tr.row-expandable:hover {\n  background-color: var(--dark-bg-tertiary);\n}\n\n.data-table tbody tr.row-expanded {\n  background-color: var(--bg-surface);\n  border-bottom: none;\n}\n\nbody.dark-theme .data-table tbody tr.row-expanded {\n  background-color: var(--dark-bg-tertiary);\n}\n\n.expand-toggle-cell {\n  text-align: center;\n  padding: 0.875rem 0.5rem !important;\n  color: var(--primary-orange);\n  user-select: none;\n}\n\n.expand-arrow {\n  display: inline-block;\n  font-size: 1.3rem;\n  line-height: 1;\n  font-weight: bold;\n  transition: transform 0.18s ease;\n  color: var(--primary-orange);\n  opacity: 0.7;\n}\n\n.expand-arrow.expanded {\n  transform: rotate(90deg);\n  opacity: 1;\n}\n\n.data-table tbody tr.row-expandable:hover .expand-arrow {\n  opacity: 1;\n}\n\n.expanded-content-row td {\n  padding: 0 !important;\n  border-bottom: 2px solid var(--primary-orange) !important;\n}\n\n.expanded-row-body {\n  padding: 1rem 1.25rem 1rem 2.75rem;\n  background-color: var(--bg-surface);\n  border-left: 3px solid var(--primary-orange);\n}\n\nbody.dark-theme .expanded-row-body {\n  background-color: var(--dark-bg-surface);\n}\n\n/* Field label/value inside expanded row */\n.exp-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-muted);\n  margin-bottom: 2px;\n}\n\nbody.dark-theme .exp-label {\n  color: var(--dark-text-muted);\n}\n\n.exp-value {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  line-height: 1.45;\n}\n\nbody.dark-theme .exp-value {\n  color: var(--dark-text-secondary);\n}\n\n.exp-grid {\n  display: grid;\n  gap: 0.5rem 2rem;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n}\n\n.exp-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* ── SidePanel ────────────────────────────────────────────── */\n.side-panel-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 1100;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.side-panel-overlay.visible {\n  opacity: 1;\n}\n\n.side-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100dvh;\n  max-width: 95vw;\n  background: var(--bg-primary);\n  border-left: 1px solid var(--border-light);\n  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.18);\n  z-index: 1101;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nbody.dark-theme .side-panel {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.55);\n}\n\n.side-panel.open {\n  transform: translateX(0);\n}\n\n.side-panel__header {\n  padding: 1.25rem 1.5rem 1rem;\n  border-bottom: 2px solid var(--primary-orange);\n  flex-shrink: 0;\n  background: var(--bg-surface);\n}\n\nbody.dark-theme .side-panel__header {\n  background: var(--dark-bg-tertiary);\n}\n\n.side-panel__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.side-panel__title {\n  color: var(--primary-orange);\n  font-size: 1.2rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.side-panel__close {\n  background: var(--bg-tertiary);\n  border: none;\n  border-radius: 4px;\n  width: 36px;\n  height: 36px;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.side-panel__close:hover {\n  background: var(--primary-orange);\n  color: white;\n  transform: scale(1.05);\n}\n\nbody.dark-theme .side-panel__close {\n  background: var(--dark-bg-secondary);\n  color: var(--dark-text-secondary);\n}\n\n.side-panel__nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.875rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--border-light);\n}\n\nbody.dark-theme .side-panel__nav {\n  border-color: var(--border-dark);\n}\n\n.side-panel__nav-btn {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  font-size: 1.4rem;\n  font-weight: bold;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary-orange);\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.side-panel__nav-btn:hover:not(:disabled) {\n  background: var(--primary-orange);\n  color: white;\n  border-color: var(--primary-orange);\n  transform: scale(1.05);\n}\n\n.side-panel__nav-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\nbody.dark-theme .side-panel__nav-btn {\n  background: var(--dark-bg-secondary);\n  border-color: var(--border-dark);\n}\n\n.side-panel__nav-label {\n  flex: 1;\n  text-align: center;\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\nbody.dark-theme .side-panel__nav-label {\n  color: var(--dark-text-muted);\n}\n\n.side-panel__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n  scrollbar-gutter: stable;\n}\n\n.side-panel__body::-webkit-scrollbar { width: 6px; }\n.side-panel__body::-webkit-scrollbar-track { background: var(--bg-tertiary); }\n.side-panel__body::-webkit-scrollbar-thumb { background: var(--border-medium); border-radius: 3px; }\n\n.side-panel__body .form-group:last-child { margin-bottom: 0; }\n\n/* Footer with actions inside side panel body */\n.side-panel__footer {\n  margin-top: 1.5rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--border-light);\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\nbody.dark-theme .side-panel__footer {\n  border-color: var(--border-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
